<template>
  <div>
    <div
        id="content"
        class="d-flex scroller"
        @click.stop="clickOnMainContent"
        @click="closeModals($event)"
    >
      <left-panel
          :product="getProduct"
          :active-page="getActivePageIndex"
          :check-modal-open="modalTruthy"
          :key="getActiveObjectId"
          :active-object="getActiveObject"
          :product-address-boxes="getProductAddressBoxes"
          :height="getSelectedPageHeight"
          :width="getSelectedPageWidth"
          :product-size="getProductSize"
          :is-alignment-guide-on="getIsAlignmentGuideOn"
          :is-gray-scale-on="getIsGrayScaleOn"
          :is-product-crop="getIsProductCrop"
          :content-list="getSelectedPageObjectList"
          :product-crop="getProductCrop"
          :is-ruler-on="getIsRulerOn"
          :product-name="getProductName"
          :is-product-size-ratio="isProductSizeRatio"
          :is-inch="getIsSizeInInches"
          :is-open-detail-section="DetailSection.isOpen"
          :is-open-shape-section="isOpenShapeSection"
          :bank-type="getProductBankType"
          :product-has-video-audio-animation="productHasVideoAudioAnimation"
          :selected-objects-list="selectedObjectsList"
          class="flex-left-panel"
          @OpenDetailSection="openDetailSection"
          @OpenShapeSection="openShapeSection"/>
      <canvas-panel
          :product="getProduct"
          :active-object="getActiveObject"
          :key="getCanvasPanelKey"
          :is-alignment-guide-on="getIsAlignmentGuideOn"
          :is-gray-scale-on="getIsGrayScaleOn"
          :height="getSelectedPageHeight"
          :width="getSelectedPageWidth"
          :base-image="getSelectedPageBaseImage"
          :content-list="getSelectedPageObjectList"
          :active-page="getActivePageIndex"
          :product-pages-length="getProductPagesLength"
          :product-crop="getProductCrop"
          :is-ruler-on="getIsRulerOn"
          :product-scale="getProductScale"
          :selected-objects-list="selectedObjectsList"
          :vertical-guides="product.verticalGuides || []"
          :horizontal-guides="product.horizontalGuides || []"
          class="flex-center-panel d-flex flex-column position-relative overflow-hidden   "/>
      <!--        :base-image="getBaseImage"
            TODO: Remove getBaseImage-->
      <right-panel
          :content-list="getSelectedPageObjectList"
          :active-object="getActiveObject"
          :product="product"
          :active-page="getActivePageIndex"
          class="flex-right-panel scroller"/>
    </div>

    <div v-show="isLoaderVisible === true">
      <div
          class="loader-styling position-absolute h-100 w-100 d-flex flex-column justify-content-center align-items-center align-content-center set-z-index">
        <Spinner
            :speed="1"
            size="huge"
            message="Loading..."
            class="inner-Loader"/>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-plusplus */
import LeftSection from '@/components/LeftSection/LeftSection';
import RightPanel from '@/components/RightPanel/RightPanel';
import CanvasPanel from '@/components/CanvasPanel/CanvasPanel';
import Text from '@/components/DesignObjects/TextObject';
import Image from '@/components/DesignObjects/ImageObject';
import Background from '@/components/DesignObjects/BackgroundObject';
import { getTableContentScale } from '@/components/DesignObjects/TableScale';
import EventBus from '@/EventBus';
import { v4 as uuidv4 } from 'uuid';
import {
  hexToRgb,
  fetchingSvg,
  helperFunctionToReverseSortByObjectKey,
  extractSvgColors,
  isFDICEHNCUA,
  applyLogoFitFromContent,
  applySvgScaleTransform,
  getSvgScaleToFitBox,
  getCropUrl,
} from '@/components/Helper';
import _ from 'lodash';
import undoRedoManager from '@/components/MainContent/mixins/undoRedoManager';
import saveProductManager from '@/components/MainContent/mixins/saveProductManager';
import axios from 'axios';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import FontFaceObserver from 'fontfaceobserver';
import {
  FDIC_LOGO_2_BLACK_SVG,
  FDIC_LOGO_2_WHITE_SVG,
  FDIC_LOGO_BLACK_SVG,
  FDIC_LOGO_WHITE_SVG,
  FDIC_TEXT_BLACK_SVG,
  FDIC_TEXT_WHITE_SVG,
  NCUA_TEXT_BLACK_SVG,
  NCUA_TEXT_WHITE_SVG,
} from '@/library/LogosSvgHelper';
import {
  assignPdfSortOrderTree,
  clearAllSelection,
  expandSelectionForProperties,
  findObjectById,
  findParentGroup,
  forEachCanvasObject,
  getPropertyApplyTargets,
  recalculateGroupBounds,
  resolveLiveObjects,
} from '@/components/Canvas/utils/groupHelpers';
import product from '../../store/modules/product';
import Spinner from 'vue-simple-spinner';

export default {
  name:       'MainContent',
  components: {
    Spinner,
    'left-panel':   LeftSection,
    'canvas-panel': CanvasPanel,
    'right-panel':  RightPanel,
  },
  mixins: [undoRedoManager, saveProductManager],
  data() {
    return {
      checkModal:  false,
      value:       0,
      modalTruthy: false,
      product:     {
        pages:              [],
        transitions:        [],
        isAlignmentGuideOn: true,
        horizontalGuides:   [],
        verticalGuides:     [],
      },
      ProductAddressBoxes: [],
      ProductHousingLogos: [],
      ProductNcuaLogos:    [],
      ProductFdicLogos:    [],
      activePage:          -1,
      selectedPage:        { objectList: [], width: 577, height: 640 },
      activeObject:        null,
      maxPDFSortOrder:     0,
      loadProductXML:      null,
      isLoaderVisible:     false,
      productPagesLength:  0,
      DetailSection:       {
        isOpen: false,
        Id:     null,
      },
      isOpenShapeSection:    false,
      isProductSizeRatio:    true,
      defaultProductWidth:   null,
      defaultProductHeight:  null,
      defaultProductName:    null,
      jsonFile:              '{"Orientation":"Horizontal","SvgShapes":"","TriviaQuestions":null,"PageWidths":{"double":1080},"PageHeights":{"double":1080},"Id":"d6b699ae-3733-46d9-8213-549a4eed6c95","BankType":"Bank","Name":"Community","CsvFilePath":null,"Size":"(1080x1080) ","IsInch":false,"IsDigitalMedia":true,"ConvertToBlackAndWhite":true,"AllowFontChanging":true,"AllowProductRename":true,"AllowSizeChange":true,"AllowCropping":false,"CropOnOff":false,"AllowFieldResize":true,"AllowFieldMove":true,"AllowFieldRotate":true,"AllowAddingTextField":true,"AllowAddingBackgroundField":true,"IsRssProduct":false,"AllowAddingImageField":true,"WidthCrop":1080,"HeightCrop":1080,"XCrop":0,"YCrop":0,"BaseImage":"https://www.bankmarketingcenter.com/temp/convertedimages/88cd54a7-49d1-49d6-86a6-60c2793b4f78base146False.png\\n","IsGrayscale":false,"isVideoEditor":true,"isVideo":true,"pages":[{"objectList":[{"croppedSrc":"none","type":"image","AllowMove":true,"AllowResize":true,"AllowRotate":true,"AlternativeImageUrls":[],"AlternativeImageUrlsResVersion":[],"DefaultImageUrl":"https://pdf-processing.bankmarketingcenter.com/svg/protectedarea/banklogos/b2225bf0-7a5c-4095-945f-96d80a1e59ef_588.svg","Height":240,"Id":"11fdf4c0-d519-11f0-9391-fb967db588a5","ImageType":"WhiteboxLogo","ImageExtension":"","IsGrayScale":true,"IsVisible":true,"IsHFlipped":false,"IsVFlipped":false,"LockAspectRatio":false,"Name":"Address Box","PageNo":-1,"PdfSortOrder":5,"RotateDegree":0,"Width":720,"X":263,"Y":827,"stencilDefaultPositionTop":null,"stencilDefaultPositionLeft":null,"stencilScale":1,"scaleX":1,"scaleY":1,"locked":false,"elementIndex":0,"isSelected":false,"isEditableForRightPanel":false,"cropScaleX":1,"cropScaleY":1,"cropOffsetX":0,"cropOffsetY":0,"isCircularCrop":0,"HighResV2Height":0,"HighResV2Width":0,"effects":{"brightness":{"value":50},"contrast":{"value":50},"saturation":{"value":50},"blur":{"value":0},"tint":{"value":0,"color":"#000"},"vignette":{"value":0},"transparency":{"value":100}},"SvgProperty":{"content":"","DefaultColor":"#000000","StrokeColor":"#000000","StrokeWidth":0,"svgScaleX":1,"svgScaleY":1,"style":"scale(1, 1)"},"HighResPath":"https://www.bankmarketingcenter.com/protectedarea/banklogos/b2225bf0-7a5c-4095-945f-96d80a1e59ef_588.pdf","isImageAddedOnCanvasFromModel":false,"croppedHighResPath":"none","DefaultImageHeight":176,"DefaultImageWidth":528,"animation":{"style":"zoomin","speed":50,"onEnter":true,"onExit":false,"distance":50},"isAnimated":true,"isGradient":false,"gradient":{"angle":0,"colors":[{"id":"1","position":0,"color":"red","isSelected":true,"rgba":"rgba(255,0,0,1)"},{"id":"2","position":94,"color":"yellow","isSelected":false,"rgba":"rgba(234,239,44,1)"}]},"objectId":"11fdf4c0-d519-11f0-9391-fb967db588a5","SortOrder":5,"pageNo":0},{"AllowMove":"true","AllowResize":"true","AllowRotate":"true","ColorSystem":"CMYK","DefaultColor":"cmyk(0% 0% 0% 0%)","Height":648,"Id":"8a5f00e5-f463-45cb-8b21-cd1878663591","IsHtml":true,"IsVisible":true,"Name":"Header","PageNo":0,"PdfSortOrder":4,"RotateDegree":0,"RotateX":0,"RotateY":0,"SortOrder":1,"Value":"%3Cdiv%3E%3Cdiv%20style%3D%22text-align%3A%20center%3B%20font-family%3A%20%26quot%3BCopperplate%20Gothic%20Bold%26quot%3B%3B%22%3E%3Cspan%20face%3D%22Copperplate%20Gothic%20Bold%22%20style%3D%22font-family%3ACopperplate%20Gothic%20Bold%3B%22%3E%3Cspan%20fontsize%3D%2275%22%20style%3D%22font-size%3A%2075px%3B%20font-family%3A%20inherit%3B%22%3EWe%20Have%20A%20Lot%20More%20Than%20Money%20Invested%20In%20This%20Community%3C%2Fspan%3E%3C%2Fspan%3E%3C%2Fdiv%3E%0A%3C%2Fdiv%3E","modifiedHtml":"%3Cdiv%3E%3Cdiv%20style%3D%22text-align%3A%20center%3B%20font-family%3A%20%26quot%3BCopperplate%20Gothic%20Bold%26quot%3B%3B%22%3E%3Cspan%20face%3D%22Copperplate%20Gothic%20Bold%22%20style%3D%22font-family%3ACopperplate%20Gothic%20Bold%3B%22%3E%3Cspan%20fontsize%3D%2275%22%20style%3D%22font-size%3A%2075px%3B%20font-family%3A%20inherit%3B%22%3EWe%20Have%20A%20Lot%20More%20Than%20Money%20Invested%20In%20This%20Community%3C%2Fspan%3E%3C%2Fspan%3E%3C%2Fdiv%3E%0A%3C%2Fdiv%3E","Width":434,"X":24,"Y":216,"elementIndex":1,"editor":null,"locked":false,"type":"text","scaleX":1,"scaleY":1,"isEditorEnable":false,"isSelected":false,"isEditableForRightPanel":false,"fontFamily":"Copperplate Gothic Bold","VerticalAlign":"Middle","fontSize":75,"lineSpacing":"1.0","color":"rgb(255,255,255)","isBold":false,"isItalic":false,"isUnderline":false,"isJustifyCenter":true,"isJustifyLeft":false,"isJustifyRight":false,"verticalAlign":"Middle","isJustify":false,"isBulletList":false,"isNumberList":false,"isSubScript":false,"isSupperScript":false,"isTextAdjustmentsNeeded":true,"valuesForLeftPanel":{"fontFamily":"\\"Copperplate Gothic Bold\\"","fontSize":75,"lineSpacing":1,"color":"rgb(255, 255, 255)","isBold":false,"isItalic":false,"isUnderline":false,"isJustifyCenter":true,"isJustifyLeft":false,"isJustifyRight":false,"isJustify":false,"isBulletList":false,"isNumberList":false,"isSubScript":false,"isSuperScript":false},"animation":{"style":"typewriter","speed":50,"onEnter":true,"onExit":false,"distance":50},"textShadow":{"textEffect":"none","angle":0,"distance":0,"shadowBlur":0,"shadowColor":"rgb(252,252,252)","transparency":0,"shadowOffsetX":0,"shadowOffsetY":0},"outLine":{"textEffect":"none","strokeWidth":0,"strokeColor":"#000000"},"isAnimated":true,"curvedHtml":"","unCurvedHtml":""},{"croppedSrc":"none","type":"image","AllowMove":"true","AllowResize":"true","AllowRotate":"true","AlternativeImageUrls":["https://www.bankmarketingcenter.com/temp/convertedimages/a733b831-1649-4d68-bc76-b5dfd6e4659afdiclogowhiteFalse.png","https://www.bankmarketingcenter.com/temp/convertedimages/7fbf9b08-fc9a-42bc-b6bf-7d50c7ed6337fdiclogoFalse.png"],"AlternativeImageUrlsResVersion":[],"DefaultImageUrl":"https://pdf-processing.bankmarketingcenter.com/svg/upload/banklogos/fdiclogowhite.svg","Height":84,"Id":"e755f56c-ed44-4aa9-84af-6f864b346ce4","ImageType":"FDICLogoWhite","ImageExtension":"png","IsGrayScale":true,"IsVisible":true,"IsHFlipped":false,"IsVFlipped":false,"LockAspectRatio":"true","Name":"Equal Housing","PageNo":1,"PdfSortOrder":3,"RotateDegree":0,"Width":75,"X":101,"Y":991,"stencilDefaultPositionTop":null,"stencilDefaultPositionLeft":null,"stencilScale":1,"scaleX":1,"scaleY":1,"locked":false,"elementIndex":2,"isSelected":false,"isEditableForRightPanel":false,"cropScaleX":1,"cropScaleY":1,"cropOffsetX":0,"cropOffsetY":0,"isCircularCrop":0,"HighResV2Height":0,"HighResV2Width":0,"effects":{"brightness":{"value":50},"contrast":{"value":50},"saturation":{"value":50},"blur":{"value":0},"tint":{"value":0,"color":"#000"},"vignette":{"value":0},"transparency":{"value":100}},"SvgProperty":{"content":"","DefaultColor":"#000000","StrokeColor":"#000000","StrokeWidth":0,"svgScaleX":1,"svgScaleY":1,"style":"scale(1, 1)"},"HighResPath":"","isImageAddedOnCanvasFromModel":false,"croppedHighResPath":"none","DefaultImageHeight":150,"DefaultImageWidth":134,"animation":{"speed":1,"style":"","startTime":0,"duration":0,"onEnter":false,"onExit":false,"distance":1},"isAnimated":false,"isGradient":false,"gradient":{"angle":0,"colors":[{"id":"1","position":0,"color":"red","isSelected":true,"rgba":"rgba(255,0,0,1)"},{"id":"2","position":94,"color":"yellow","isSelected":false,"rgba":"rgba(234,239,44,1)"}]},"SortOrder":-1,"IsGrayscale":false},{"croppedSrc":"none","type":"image","AllowMove":"true","AllowResize":"true","AllowRotate":"true","AlternativeImageUrls":["https://www.bankmarketingcenter.com/temp/convertedimages/251638cf-fc6d-4897-9819-e648b8835fdafdictextwhiteFalse.png","https://www.bankmarketingcenter.com/temp/convertedimages/23087ee3-d674-4fa7-b1ba-ffdf936e66f6fdictextFalse.png"],"AlternativeImageUrlsResVersion":[],"DefaultImageUrl":"https://pdf-processing.bankmarketingcenter.com/svg/upload/banklogos/fdictextwhite.svg","Height":52,"Id":"3be362e8-b724-4cb7-a6e8-f1a3a77618c9","ImageType":"FDICTextWhite","ImageExtension":"png","IsGrayScale":true,"IsVisible":true,"IsHFlipped":false,"IsVFlipped":false,"LockAspectRatio":"true","Name":"FDIC","PageNo":1,"PdfSortOrder":2,"RotateDegree":0,"Width":89,"X":13,"Y":999,"stencilDefaultPositionTop":null,"stencilDefaultPositionLeft":null,"stencilScale":1,"scaleX":1,"scaleY":1,"locked":false,"elementIndex":3,"isSelected":false,"isEditableForRightPanel":false,"cropScaleX":1,"cropScaleY":1,"cropOffsetX":0,"cropOffsetY":0,"isCircularCrop":0,"HighResV2Height":0,"HighResV2Width":0,"effects":{"brightness":{"value":50},"contrast":{"value":50},"saturation":{"value":50},"blur":{"value":0},"tint":{"value":0,"color":"#000"},"vignette":{"value":0},"transparency":{"value":100}},"SvgProperty":{"content":"","DefaultColor":"#000000","StrokeColor":"#000000","StrokeWidth":0,"svgScaleX":1,"svgScaleY":1,"style":"scale(1, 1)"},"HighResPath":"","isImageAddedOnCanvasFromModel":false,"croppedHighResPath":"none","DefaultImageHeight":150,"DefaultImageWidth":253,"animation":{"speed":1,"style":"","startTime":0,"duration":0,"onEnter":false,"onExit":false,"distance":1},"isAnimated":false,"isGradient":false,"gradient":{"angle":0,"colors":[{"id":"1","position":0,"color":"red","isSelected":true,"rgba":"rgba(255,0,0,1)"},{"id":"2","position":94,"color":"yellow","isSelected":false,"rgba":"rgba(234,239,44,1)"}]},"SortOrder":-1,"IsGrayscale":false},{"croppedSrc":"https%3A%2F%2Fpdf-processing.bankmarketingcenter.com%2Fnode%2Fimage%3Fwidth%3D425%26height%3D768%26top%3D-1.1368683772161603e-13%26left%3D432%26src%3Dhttps%3A%2F%2Fwww.bankmarketingcenter.com%2Ftemp%2Fuploadedimages%2FmyImage297.png","type":"image","AllowMove":"true","AllowResize":"true","AllowRotate":"true","AlternativeImageUrls":["https://www.bankmarketingcenter.com/protectedarea/images/201911/29d8ab1a-edf4-4708-873a-7fc9fac4e6f7Img19-resized-600.jpg#29d8ab1a-edf4-4708-873a-7fc9fac4e6f7","https://www.bankmarketingcenter.com/protectedarea/images/201911/eeca5afc-8ecf-49a3-9518-99892b4b3c8eImg3059-resized-600.jpg#eeca5afc-8ecf-49a3-9518-99892b4b3c8e","https://www.bankmarketingcenter.com/protectedarea/images/201911/921b36e5-2b33-42e3-bc84-f61e81854ab8Img2042-resized-600.jpg#921b36e5-2b33-42e3-bc84-f61e81854ab8"],"AlternativeImageUrlsResVersion":[{"DefaultImageUrl":"https://www.bankmarketingcenter.com/protectedarea/images/201911/29d8ab1a-edf4-4708-873a-7fc9fac4e6f7Img19-resized-600.jpg#29d8ab1a-edf4-4708-873a-7fc9fac4e6f7 ","HighResImageUrl":"","HighResV2Width":"","HighResV2Height":""},{"DefaultImageUrl":"https://www.bankmarketingcenter.com/protectedarea/images/201911/eeca5afc-8ecf-49a3-9518-99892b4b3c8eImg3059-resized-600.jpg#eeca5afc-8ecf-49a3-9518-99892b4b3c8e","HighResImageUrl":"https://www.bankmarketingcenter.com/protectedarea/images/201911/Img3059.jpg","HighResV2Width":"1121","HighResV2Height":"2033"},{"DefaultImageUrl":"https://www.bankmarketingcenter.com/protectedarea/images/201911/921b36e5-2b33-42e3-bc84-f61e81854ab8Img2042-resized-600.jpg#921b36e5-2b33-42e3-bc84-f61e81854ab8","HighResImageUrl":"https://www.bankmarketingcenter.com/protectedarea/images/201911/Img2042.jpg","HighResV2Width":"1171","HighResV2Height":"2121"},{"Id":"aaab7010-dcf6-4851-b507-5cbe2b46f99c","Name":"myImage.png","DefaultImageUrl":"https://www.bankmarketingcenter.com/temp/uploadedimages/myImage297.png","ImageType":"Image","CropOption":"NotSpecified","ImageThumbnailPath":"https%3A%2F%2Fwww.bankmarketingcenter.com%2Fthumbnails%2F80-80--temp-uploadedimages-myImage297.png","ImageThumbnailPathV2":"https%3A%2F%2Fwww.bankmarketingcenter.com%2Fthumbnails%2F80-80--temp-uploadedimages-myImage297.png","previousDefaultImageUrl":"https://www.bankmarketingcenter.com/temp/uploadedimages/aaab7010-dcf6-4851-b507-5cbe2b46f99cmyImage-resized-600.png#aaab7010-dcf6-4851-b507-5cbe2b46f99c"}],"DefaultImageUrl":"https%3A%2F%2Fwww.bankmarketingcenter.com%2Ftemp%2Fuploadedimages%2FmyImage297.png","Height":1080,"Id":"ee687963-e7cb-4589-b5e5-92de700c35dc","ImageType":"Image","ImageExtension":"jpg","IsGrayScale":true,"IsVisible":true,"IsHFlipped":false,"IsVFlipped":false,"LockAspectRatio":"false","Name":"Photo","PageNo":1,"PdfSortOrder":1,"RotateDegree":0,"Width":597,"X":484,"Y":0,"stencilDefaultPositionTop":-1.1368683772161603e-13,"stencilDefaultPositionLeft":432,"stencilScale":1.3020658849804578,"scaleX":1,"scaleY":1,"locked":false,"elementIndex":4,"isSelected":false,"isEditableForRightPanel":false,"cropScaleX":1,"cropScaleY":1,"cropOffsetX":0,"cropOffsetY":0,"isCircularCrop":0,"effects":{"brightness":{"value":50},"contrast":{"value":50},"saturation":{"value":50},"blur":{"value":0},"tint":{"value":0,"color":"#000"},"vignette":{"value":0},"transparency":{"value":100}},"SvgProperty":{"content":"","DefaultColor":"#000000","StrokeColor":"#000000","StrokeWidth":0,"svgScaleX":1,"svgScaleY":1,"style":"scale(1, 1)"},"isImageAddedOnCanvasFromModel":false,"croppedHighResPath":"https%3A%2F%2Fpdf-processing.bankmarketingcenter.com%2Fnode%2Fimage%3Fwidth%3D425%26height%3D768%26top%3D-1.1368683772161603e-13%26left%3D432%26src%3Dundefined","DefaultImageHeight":768,"DefaultImageWidth":1408,"animation":{"speed":1,"style":"","startTime":0,"duration":0,"onEnter":false,"onExit":false,"distance":1},"isAnimated":false,"isGradient":false,"gradient":{"angle":0,"colors":[{"id":"1","position":0,"color":"red","isSelected":true,"rgba":"rgba(255,0,0,1)"},{"id":"2","position":94,"color":"yellow","isSelected":false,"rgba":"rgba(234,239,44,1)"}]},"SortOrder":-1,"IsGrayscale":false,"tempIndex":"4","coordinates":{"width":425,"height":768,"left":432,"top":-1.1368683772161603e-13},"HighResPath":"undefined"},{"polygonWidth":0,"polygonHeight":0,"svgScaleX":1,"svgScaleY":1,"AllowMove":"true","AllowResize":"true","AllowRotate":"true","Alpha":"100","ColorSystem":"RGB","DefaultColor":"rgba(8, 130, 81, 1)","StrokeWidth":0,"Height":1080,"Id":"98bcf0ed-2a10-4e94-98bc-4042126696c0","IsEditable":true,"IsHFlipped":false,"IsVFlipped":false,"IsVisible":true,"LayerPanelValue":false,"Name":"Color","PageNo":0,"PdfSortOrder":0,"PolygonPoints":"","RotateDegree":0,"RotateX":0,"RotateY":0,"SortOrder":1,"UseRgb":false,"Width":1080,"X":0,"Y":0,"type":"shape","scaleX":1,"scaleY":1,"locked":false,"isSelected":false,"initialX":0,"initialY":0,"shapeType":"rectangle","isEditableForRightPanel":false,"elementIndex":5,"isNewObject":false,"svgContent":"","animation":{"speed":1,"style":"","startTime":0,"duration":0,"onEnter":false,"onExit":false},"isAnimated":false,"isGradient":false,"gradient":{"angle":0,"colors":[{"id":"1","position":0,"color":"red","isSelected":true,"rgba":"rgba(8, 130, 81, 1)"},{"id":"2","position":94,"color":"yellow","isSelected":false,"rgba":"rgba(234,239,44,1)"}]},"ColorType":"ColorPack","SvgProperty":{"content":"%3Csvg%20data-v-4bf63e30%3D%22%22%20viewBox%3D%220%200%201080%201080%22%20width%3D%221080%22%20height%3D%221080%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20style%3D%22transform%3A%20scale(1%2C%201)%3B%20transform-origin%3A%20left%20top%3B%20vertical-align%3A%20middle%3B%20overflow%3A%20visible%3B%22%3E%3Cdefs%3E%3ClinearGradient%20id%3D%22gradient-98bcf0ed-2a10-4e94-98bc-4042126696c0%22%20gradientTransform%3D%22rotate(0)%22%3E%3Cstop%20offset%3D%220%25%22%20stop-color%3D%22rgba(255%2C0%2C0%2C1)%22%3E%3C%2Fstop%3E%3Cstop%20offset%3D%2294%25%22%20stop-color%3D%22rgba(234%2C239%2C44%2C1)%22%3E%3C%2Fstop%3E%3C%2FlinearGradient%3E%3C%2Fdefs%3E%3C!----%3E%3Crect%20data-v-4bf63e30%3D%22%22%20width%3D%221080%22%20height%3D%221080%22%20style%3D%22fill%3A%20rgb(218%2C%2029%2C%2072)%3B%20stroke-width%3A%200px%3B%22%20fill%3D%22url(%23gradient-98bcf0ed-2a10-4e94-98bc-4042126696c0)%22%3E%3C%2Frect%3E%3C%2Fsvg%3E"}}],"width":1080,"height":1080,"baseImage":"https://www.bankmarketingcenter.com/temp/convertedimages/88cd54a7-49d1-49d6-86a6-60c2793b4f78base146False.png","animation":{"speed":1,"style":"pageAnimationNone","startTime":0,"duration":5,"onEnter":false,"onExit":false,"timeLineWidth":140}}],"scaleX":1,"scaleY":1,"isShowCrop":false,"isEditedByNewEditor":true,"pdfUrl":"https://pdf-processing.bankmarketingcenter.com/pdf/designs/design-69F0QSLqpY-merged.pdf","submittedAs":"image"}',
      reRenderer:            1,
      selectedObjectsList:   [],
      prevHasVideoAnimation: false,
    }; // TODO: Muaaz kindly add this in config file
  },

  computed: {
    getProductScale() {
      return [this.product.scaleX, this.product.scaleY];
    },
    getProductBankType() {
      if (!this.product) {
        return '';
      }
      return this.product.BankType;
    },
    getIsSizeInInches() {
      return this.product.IsInch;
    },
    getProductCrop() {
      if (this.activePage < 0) {
        return {};
      }
      const {
        AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop,
      } = this.product;
      return {
        AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop,
      };
    },

    /**
     * CHANGES: Always show Product actual width and ignore crop mark width
     * Changed this section to ignore crop marks size when shwoing
     * product width and height. Alternatively, to incorporate crop marks
     * check If crop marks i.e. product.AllowCropping = true then return this.product.WidthCrop
     * else return getSelectedPageWidth
     */

    getCropWidth() {
      if (this.activePage < 0) {
        return 577;
      }
      return Math.round(parseFloat(this.product.XCrop)) > 0 ? Math.round(parseFloat(this.product.WidthCrop)) : this.getSelectedPageWidth;
    },
    getCropHeight() {
      if (this.activePage < 0) {
        return 640;
      }
      return Math.round(parseFloat(this.product.YCrop)) > 0 ? Math.round(parseFloat(this.product.HeightCrop)) : this.getSelectedPageHeight;
    },
    getIsAlignmentGuideOn() {
      return this.product.isAlignmentGuideOn;
    },
    getIsGrayScaleOn() {
      return this.product.IsGrayscale;
    },
    getProductSize() {
      return this.product.IsInch ? this.getProductSizeInches : this.getProductSizePixel;
      // return {width: , height: }
    },
    getProductName() {
      return this.product.Name;
    },
    getProductSizePixel() {
      return {
        width:        this.getCropWidth,
        height:       this.getCropHeight,
        selectedUnit: 'Pixels',
        otherUnit:    'Inches',
      };
    },
    getProductSizeInches() {
      const height = this.getCropHeight;
      const width  = this.getCropWidth;
      // this.product.AllowCropping && (width = this.getCropWidth);
      // this.product.AllowCropping && (height = this.getCropHeight);

      const inchesWidth  = width * 0.013888888888888888;
      const inchesHeight = height * 0.013888888888888888;
      return {
        width:        inchesWidth.toFixed(2),
        height:       inchesHeight.toFixed(2),
        selectedUnit: 'Inches',
        otherUnit:    'Pixels',
      };
    },

    getIsProductCrop() {
      return { allowCrop: this.product.AllowCropping, isShowCrop: this.product.isShowCrop };
    },
    getIsRulerOn() {
      return this.product.isRulerOn || false;
    },
    getProductPagesLength() {
      return this.productPagesLength;
    },
    getProductAddressBoxes() {
      return this.ProductAddressBoxes;
    },
    getEqualHousingLogos() {
      return this.ProductHousingLogos;
    },
    getNcuaLogos() {
      return this.ProductNcuaLogos;
    },
    getFdicLogos() {
      return this.ProductFdicLogos;
    },
    getActiveObjectId() {
      if (this.activeObject != null) {
        return this.activeObject.Id;
      }
      return '';
    },
    getSelectedPage() {
      return this.selectedPage;
    },
    getCanvasPanelKey() {
      return `${uuidv4()}-${this.getSelectedPageWidth}-${this.getSelectedPageHeight}-${this.reRenderer}`;
    },
    getLeftPanelKey() {
      console.log('new left panel key');
      return `${uuidv4()}-${this.getSelectedPageWidth}-${this.getSelectedPageHeight}`;
    },
    getActiveObject() {
      this.activeObject && this.closeDetailsection();
      return this.activeObject;
    },
    getSelectedPageObjectList() {
      return this.activePage > -1 ? this.product.pages[this.activePage].objectList : [];
    },
    getSelectedPageWidth() {
      if (this.activePage > -1) {
        console.log('Seleceted Page width is ', this.product.pages[this.activePage].width);
      }
      return this.activePage > -1 ? this.product.pages[this.activePage].width : 0;
    },
    getSelectedPageHeight() {
      return this.activePage > -1 ? this.product.pages[this.activePage].height : 0;
    },
    getSelectedPageBaseImage() {
      return this.activePage > -1 ? this.product.pages[this.activePage].baseImage : '';
    },
    getActivePageIndex() {
      return this.activePage;
    },
    getOpacityValues() {
      return this.value;
    },
    getProduct() {
      return this.activePage > -1 ? this.product : null;
    },
    productHasVideoAudioAnimation() {
      return this.computeProductHasVideoOrElementAnimation();
    },
  },
  watch: {
    getActivePageIndex: {
      handler() {
        EventBus.$emit('updateProductActivePageIndex', this.getActivePageIndex);
        EventBus.$emit('changeUndoRedoRestButtonOnPageChange');
      },
    },
    getSelectedPageObjectList: {
      deep: true,
      handler() {
        EventBus.$emit('updateProductInHeader', this.getSelectedPageObjectList);
      },
    },
    getSelectedPageHeight: {
      deep: true,
      handler() {
        EventBus.$emit('updateSelectedPageHeightInHeader', this.getSelectedPageHeight);
      },
    },
    getSelectedPageWidth: {
      deep: true,
      handler() {
        EventBus.$emit('updateSelectedPageWidthInHeader', this.getSelectedPageWidth);
      },
    },
    getProductCrop: {
      deep: true,
      handler() {
        EventBus.$emit('updateProductCropMark', this.getProductCrop);
      },
    },
    product: {
      deep: true,
      handler(newProduct) {
        EventBus.$emit('onUpdateProduct', this.getProduct);
        this.syncVideoModeWithProduct();
      },
    },
  },
  mounted() {
    this.loadSvgShapeCategories();
    this.loadSvgShapes();
    this.getFavouriteSizes();
    this.loadUserInfo();
    const urlSearchPart      = window.location.search;
    const newUrlSearchParams = new URLSearchParams(urlSearchPart);

    if (!newUrlSearchParams.has('productId') && !newUrlSearchParams.has('orderitem_id')) {
      // this.parseProductFromXML(this.$xml2);
      // this.loadProductFromJson(this.jsonFile)

    }

    // :Event Bus on listener
    EventBus.$on('selectedProductOption', this.selectedProductRecieved);
    EventBus.$on('updateProductPagesOrder', this.updateProductPagesOrder);
    EventBus.$on(ApplicationEventTypes.ProductLoadingEvents.UPDATE_HTML_AFTER_ENABLE_EDITOR, this.onUpdateHTML);
    EventBus.$on(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.onUpdateContentListIndexOnLayerSwap);
    EventBus.$on(ApplicationEventTypes.UndoRedoEvents.ADDED, this.onAddIntoPageWiseUndoRedoArray);
    EventBus.$on(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, this.onUpdateProductByPageWiseUndoRedo);
    EventBus.$on(ApplicationEventTypes.UndoRedoEvents.RESET_PAGE_UNDO_REDO, this.resetSpecificUndoRedoArray);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_CHANGE, this.onChangeProductPage);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_DELETE, this.onDeleteProductPage);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_DUPLICATE, this.onDuplicateProductPage);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_CREATE, this.onCreateNewProductPage);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_PRODUCT_SIZE_FROM_DROPDOWN, this.changeProductSizeFromDropDown);
    EventBus.$on('changeFontStyle', this.updateStyle);
    EventBus.$on('updateObjectAfterCrop', this.onUpdateObjectAfterCrop);
    EventBus.$on('onObjectAdding', this.onObjectAdding);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.SELECTED, this.onObjectSelected);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onObjectSelectedCleared);
    EventBus.$on('toggleBulletList', this.changeToggleBulletList);
    EventBus.$on('toggleNumberList', this.changeToggleNumberList);
    EventBus.$on('toggleSupperScriptList', this.changetoggleSupperScriptList);
    EventBus.$on('toggleSubScriptList', this.changetoggleSubScriptList);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.RESET_PRODUCT_SIZE, this.setDefaultProduct);

    EventBus.$on('saveProduct', this.onSaveProduct);
    EventBus.$on('updatePageContent', this.updatePageContent);
    EventBus.$on('showHideLoader', this.updateIsLoaderVisible);
    EventBus.$on('pushValues', this.onReceivePushedValue);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.RESET, this.deSelectActiveObject);
    EventBus.$on('changeProductAllowCropping', this.changeProductAllowCropping);
    EventBus.$on('changeAllowAlignmentGuides', this.onChangeAllowAlignmentGuides);
    EventBus.$on('changeProductSizeAfterResize', this.onChangeProductSizeAfterResize);
    EventBus.$on('changeProductName', this.onChangeProductName);
    EventBus.$on('toggleProductSizeRatioFlag', this.onToggleProductSizeRatioFlag);
    EventBus.$on('toggleGrayScale', this.onToggleGrayScale);
    EventBus.$on('toggleRuler', this.onToggleRuler);
    EventBus.$on('updateProductSize', this.changeProductSize);
    EventBus.$on('updateProductColor', this.updateProductColorList);
    EventBus.$on('ReplaceHighResResources', this.onReplaceHighResResources);
    EventBus.$on('loadProductFromJson', this.loadProductFromJson);
    EventBus.$on('UpdateTextObjectValue', this.updateTextObjectValue);
    EventBus.$on('deleteFavouriteSize', this.deleteFavouriteSize);
    EventBus.$on('addFavouriteSizeToAPI', this.addFavouriteSizeToAPI);
    EventBus.$on(ApplicationEventTypes.TransitionEvents.ADD_TRANSITION, this.applyPageTransition);
    EventBus.$on(ApplicationEventTypes.TransitionEvents.UPDATE_TRANSITION, this.updatePagesTransition);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PAGE_DURATION_UPDATE, this.updateProductPageDuration);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.ACTIVE_PAGE_DURATION_UPDATE, this.updateActivePageDuration);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.UPDATE_PRODUCT_TRANSITION_OBJECT, this.updateProductTransitionObjects);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.UPDATE_PAGE_UNDO_REDO_OBJ, this.updatePageUndoRedoObject);
    EventBus.$on(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, this.AddNewAudio);
    EventBus.$on(ApplicationEventTypes.Video.ToggleVideoMood, this.toggleVideoMood);
    EventBus.$on(ApplicationEventTypes.Video.UPDATE_VIDEO_URL_ATTR_IN_PRODUCT, this.updateVideoAttrInProduct);
    EventBus.$on(ApplicationEventTypes.Video.UPDATE_VIDEO_WATERMARK_URL_ATTR_IN_PRODUCT, this.updateVideoWatermarkAttrInProduct);
    EventBus.$on(ApplicationEventTypes.Video.UPDATE_VIDEO_GIF_URL_ATTR_IN_PRODUCT, this.updateVideoGifAttrInProduct);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.PRODUCT_PAGES_SHOULD_BE_SAME, this.allPagesShouldBeSame);
    EventBus.$on(ApplicationEventTypes.ProductSave.SAVE_PRODUCT_AS_TEMPLATE, this.saveProductAsTemplate);
    EventBus.$on(ApplicationEventTypes.ImageObjectEvents.SELECTED_VIDEO_FOR_LEFT_PANEL, this.addingAlternativeVideo);
    EventBus.$on(ApplicationEventTypes.ImageObjectEvents.REPLACE_VIDEO, this.replaceCanvasVideo);
    EventBus.$on('replaceBgRemoverImageUrl', this.replaceBgRemoverImageUrl);
    EventBus.$on(ApplicationEventTypes.Canvas.CANVAS_RE_RENDER, this.rerender);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.SELECTED_OBJETCS, this.getSelectedObjectsList);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.MULTI_OBJETCS_CLEAR, this.onClearMultiSelection);
    EventBus.$on(ApplicationEventTypes.Product.RESET_PRODUCT_THUMBNAILS_DURATION_WIDTH, this.resetPagesThumbnailWidthAndTime);
    EventBus.$on(ApplicationEventTypes.Product.SYNC_VIDEO_MODE_AFTER_ELEMENT_ANIMATION, this.syncVideoModeAfterElementAnimation);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECTS, this.flipObjects);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.PRODUCT_ALIGNMENT_GUIDE, this.onChangeAllowAlignmentGuides);
    EventBus.$on(ApplicationEventTypes.GuidesEvents.VERTICAL_GUIDE_UPDATE, this.verticalGuideUpdate);
    EventBus.$on(ApplicationEventTypes.GuidesEvents.HORIZONTAL_GUIDE_UPDATE, this.horizontalGuideUpdate);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_IMAGE_BORDER_WIDTH, this.changeImageBorderWidth);
    EventBus.$on(ApplicationEventTypes.Canvas.UPDATE_TEXT_FROM_AI, this.updateTextFromAi);
  },
  beforeDestroy() {
    EventBus.$off('updateProductPagesOrder', this.updateProductPagesOrder);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_PRODUCT_SIZE_FROM_DROPDOWN, this.changeProductSizeFromDropDown);
    EventBus.$off('updateObjectAfterCrop');
    EventBus.$off('toggleProductSizeRatioFlag', this.onToggleProductSizeRatioFlag);
    EventBus.$off(ApplicationEventTypes.ProductLoadingEvents.UPDATE_HTML_AFTER_ENABLE_EDITOR, this.onUpdateHTML);
    EventBus.$off(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.onUpdateContentListIndexOnLayerSwap);
    EventBus.$off(ApplicationEventTypes.UndoRedoEvents.ADDED, this.onAddIntoPageWiseUndoRedoArray);
    EventBus.$off(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, this.onUpdateProductByPageWiseUndoRedo);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_CHANGE, this.onChangeProductPage);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_DELETE, this.onDeleteProductPage);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_DUPLICATE, this.onDuplicateProductPage);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_CREATE, this.onCreateNewProductPage);
    EventBus.$off('changeFontStyle', this.updateStyle);
    EventBus.$off('changeAllowAlignmentGuides', this.onChangeAllowAlignmentGuides);
    EventBus.$off('toggleGrayScale', this.onToggleGrayScale);
    EventBus.$off('changeProductSize', this.changeProductSize);
    EventBus.$off('changeProductSizeAfterResize', this.onChangeProductSizeAfterResize);
    EventBus.$off('changeProductName', this.onChangeProductName);
    EventBus.$off('onObjectAdding', this.onObjectAdding);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.SELECTED, this.onObjectSelected);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onObjectSelectedCleared);
    EventBus.$off('toggleBulletList', this.changeToggleBulletList);
    EventBus.$off('toggleNumberList', this.changeToggleNumberList);
    EventBus.$off('toggleSupperScriptList', this.changetoggleSupperScriptList);
    EventBus.$off('toggleSubScriptList', this.changetoggleSubScriptList);
    EventBus.$off('selectedProductOption', this.selectedProductRecieved);
    EventBus.$off('saveProduct', this.onSaveProduct);
    EventBus.$off('updatePageContent', this.updatePageContent);
    EventBus.$off('showHideLoader', this.updateIsLoaderVisible);
    EventBus.$off('pushValues', this.onReceivePushedValue);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.RESET, this.deSelectActiveObject);
    EventBus.$off('changeProductAllowCropping', this.changeProductAllowCropping);
    EventBus.$off('updateProductSize');
    EventBus.$off('toggleRuler');
    EventBus.$off('updateProductColor', this.updateProductColorList);
    EventBus.$off('ReplaceHighResResources', this.onReplaceHighResResources);
    EventBus.$off('loadProductFromJson', this.loadProductFromJson);
    EventBus.$off('UpdateTextObjectValue', this.updateTextObjectValue);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.RESET_PRODUCT_SIZE);
    EventBus.$off(ApplicationEventTypes.TransitionEvents.ADD_TRANSITION, this.applyPageTransition);
    EventBus.$off(ApplicationEventTypes.TransitionEvents.UPDATE_TRANSITION, this.updatePagesTransition);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PAGE_DURATION_UPDATE, this.updateProductPageDuration);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.ACTIVE_PAGE_DURATION_UPDATE, this.updateActivePageDuration);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.UPDATE_PRODUCT_TRANSITION_OBJECT, this.updateProductTransitionObjects);
    EventBus.$off(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, this.AddNewAudio);
    EventBus.$off(ApplicationEventTypes.Video.ToggleVideoMood, this.toggleVideoMood);
    EventBus.$off(ApplicationEventTypes.Video.UPDATE_VIDEO_URL_ATTR_IN_PRODUCT, this.updateVideoAttrInProduct);
    EventBus.$off(ApplicationEventTypes.Video.UPDATE_VIDEO_WATERMARK_URL_ATTR_IN_PRODUCT, this.updateVideoWatermarkAttrInProduct);
    EventBus.$off(ApplicationEventTypes.Video.UPDATE_VIDEO_GIF_URL_ATTR_IN_PRODUCT, this.updateVideoGifAttrInProduct);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.PRODUCT_PAGES_SHOULD_BE_SAME, this.allPagesShouldBeSame);
    EventBus.$off(ApplicationEventTypes.ProductSave.SAVE_PRODUCT_AS_TEMPLATE, this.saveProductAsTemplate);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.SELECTED_VIDEO_FOR_LEFT_PANEL, this.addingAlternativeVideo);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.REPLACE_VIDEO, this.replaceCanvasVideo);
    EventBus.$off('replaceBgRemoverImageUrl', this.replaceBgRemoverImageUrl);
    EventBus.$off(ApplicationEventTypes.Canvas.CANVAS_RE_RENDER, this.rerender);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.SELECTED_OBJETCS, this.getSelectedObjectsList);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.MULTI_OBJETCS_CLEAR, this.onClearMultiSelection);
    EventBus.$off(ApplicationEventTypes.Product.RESET_PRODUCT_THUMBNAILS_DURATION_WIDTH, this.resetPagesThumbnailWidthAndTime);
    EventBus.$off(ApplicationEventTypes.Product.SYNC_VIDEO_MODE_AFTER_ELEMENT_ANIMATION, this.syncVideoModeAfterElementAnimation);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECTS, this.flipObjects);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.PRODUCT_ALIGNMENT_GUIDE, this.onChangeAllowAlignmentGuides);
    EventBus.$off(ApplicationEventTypes.GuidesEvents.VERTICAL_GUIDE_UPDATE);
    EventBus.$off(ApplicationEventTypes.GuidesEvents.HORIZONTAL_GUIDE_UPDATE);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_IMAGE_BORDER_WIDTH, this.changeImageBorderWidth);
    EventBus.$off(ApplicationEventTypes.Canvas.UPDATE_TEXT_FROM_AI, this.updateTextFromAi);
  },
  beforeUpdate() {
    const urlSearchPart      = window.location.search;
    const newUrlSearchParams = new URLSearchParams(urlSearchPart);
    if (!newUrlSearchParams.has('productId') && !newUrlSearchParams.has('orderitem_id')) {
      this.sortContentListArray();
    }
  },
  methods: {
    computeProductHasVideoOrElementAnimation() {
      if (!this.product || !this.product.pages) {
        return false;
      }
      const transitions = this.product.transitions;
      if (Array.isArray(transitions) && transitions.some((transition) => {
        const name = transition && transition.name != null ? String(transition.name).trim() : '';
        return name !== '' && name !== 'transitionNone' && name !== 'pageAnimationNone';
      })) {
        return true;
      }
      let found = false;
      this.product.pages.forEach((page) => {
        if (!page.objectList) {
          return;
        }
        forEachCanvasObject(page.objectList, (object) => {
          if (object.type === 'video') {
            found = true;
            return;
          }
          const style = object.animation && object.animation.style != null
              ? String(object.animation.style).trim()
              : '';
          if (style !== '') {
            found = true;
          }
        });
      });
      return found;
    },
    syncVideoModeAfterElementAnimation() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const hasAny = this.computeProductHasVideoOrElementAnimation();
          this.prevHasVideoAnimation = hasAny;
          if (!hasAny && this.$store.getters['activeProduct/getIsVideoMoodOn']) {
            this.$store.commit('activeProduct/updateIsVideoMoodOn', false);
            this.$store.commit('activeProduct/updateIsVideoEditor', false);
            if (this.product) {
              this.product.isVideo = false;
              this.product.isVideoEditor = false;
            }
            EventBus.$emit(ApplicationEventTypes.Product.RESET_PRODUCT_THUMBNAILS_DURATION_WIDTH);
          }
        });
      });
    },
    syncVideoModeWithProduct() {
      const hasAny = this.computeProductHasVideoOrElementAnimation();
      const isVideoModeOn = this.$store.getters['activeProduct/getIsVideoMoodOn'];

      // Auto ON: any animation/video present & mode currently OFF.
      if (hasAny && !isVideoModeOn) {
        this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
        this.$store.commit('activeProduct/updateIsVideoEditor', true);
        EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
      }

      // Auto OFF: transitioned from having animations to none.
      if (!hasAny && this.prevHasVideoAnimation && isVideoModeOn) {
        this.$store.commit('activeProduct/updateIsVideoMoodOn', false);
        this.$store.commit('activeProduct/updateIsVideoEditor', false);
        if (this.product) {
          this.product.isVideo = false;
          this.product.isVideoEditor = false;
        }
        EventBus.$emit(ApplicationEventTypes.Product.RESET_PRODUCT_THUMBNAILS_DURATION_WIDTH);
      }

      // Track previous state for next call.
      this.prevHasVideoAnimation = hasAny;
    },
    replaceBgRemoverImageUrl(src) {
      if (this.activeObject != null && this.activePage > -1) {
        const tempProduct = _.cloneDeep(this.product);
        const objectList = tempProduct.pages[this.activePage].objectList;
        let selectedObject = findObjectById(objectList, this.activeObject.Id);

        if (selectedObject && selectedObject.type === 'group') {
          const fromList = (this.selectedObjectsList || []).find(obj => obj && obj.ImageType === 'Image');
          const child = fromList
              || (selectedObject.children || []).find(obj => obj && obj.ImageType === 'Image');
          if (child) {
            selectedObject = findObjectById(objectList, child.Id) || child;
          }
        }

        if (selectedObject && selectedObject.ImageType === 'Image') {
          const cropUrl = getCropUrl(selectedObject);
          if (cropUrl) {
            const recroppedUrl = `${cropUrl.split('&src=')[0]}&src=${src}`;
            selectedObject.croppedSrc = recroppedUrl;
            selectedObject.croppedHighResPath = recroppedUrl;
          } else if (selectedObject.croppedSrc && selectedObject.croppedSrc !== 'none') {
            selectedObject.croppedSrc = src;
            selectedObject.croppedHighResPath = src;
          }
          selectedObject.HighResPath = src;
          selectedObject.isBackgroundRemoved = true;
          selectedObject.DefaultImageUrl = src;

          clearAllSelection(objectList);
          this.product = tempProduct;
          EventBus.$emit('addIntoPageWiseUndoRedoArray', 'Replace image');
        }
      }
      EventBus.$emit('showHideLoader', false);
      this.activeObject = null;
      this.selectedObjectsList = [];
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      this.rerender();
    },
    rerender() {
      this.reRenderer++;
    },
    replaceCanvasVideo(videoObj) {
      if (this.activeObject != null) {
        const objectList = _.cloneDeep(this.product.pages[this.activePage].objectList);
        const selectedObject = findObjectById(objectList, this.activeObject.Id);

        selectedObject.Name = videoObj.Name;
        selectedObject.videoDetails = {
          VideoSourceUrl: videoObj.LowResUrl,
          duration: videoObj.Duration,
          endTime: videoObj.Duration,
          startTime: 0,
          width: videoObj.Width,
          height: videoObj.Height,
          mimeType: 'video/mp4',
          audio: (!videoObj.AudioUrl || videoObj.AudioUrl.length < 10) ? 'https://video-processing.bankmarketingcenter.com/ffmpeg-video/audio-6ybTJmVkIN.mp3' : videoObj.AudioUrl,
          videoHighRes: videoObj.HighResUrl,
        };
        this.activeObject = _.cloneDeep(selectedObject);
        this.rerender();
        EventBus.$emit('SetPageVideoLength', videoObj.Duration);
        EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, objectList);
        EventBus.$emit('addIntoPageWiseUndoRedoArray', 'Replace Video');
      }
    },
    addingAlternativeVideo(data) {
      const objectList = _.cloneDeep(this.product.pages[this.activePage].objectList);
      const selectedObject = findObjectById(objectList, this.activeObject.Id);
      if (!selectedObject.AlternativeVideoUrlsResVersion) {
        selectedObject.AlternativeVideoUrlsResVersion = [];
      }
      selectedObject.AlternativeVideoUrlsResVersion.push(data);

      this.activeObject = selectedObject;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, objectList);

      this.$store.commit('setIsVideoModel', false);
      this.$store.commit('setDisplayAddVideoModal', false);
    },
    updateProductPagesOrder(pages) {
      const cloneProduct = _.cloneDeep(this.product);
      cloneProduct.pages = pages;

      this.product = cloneProduct;
    },
    async AllProductPagesShouldHaveSameDimensions(data) {
      if ((data.newWidth && parseInt(data.newWidth, 10) < 1) || (data.newHeight && parseInt(data.newHeight, 10) < 1)) {
        return;
      }

      const cloneProduct = _.cloneDeep(this.product);

      const oldWidth = parseFloat(this.getCropWidth);
      const oldHeight = parseFloat(this.getCropHeight);

      const newWidth = data.newWidth;
      const newHeight = data.newHeight;
      const isCropX = Math.round(parseFloat(this.product.XCrop)) > 0;
      const isCropY = Math.round(parseFloat(this.product.YCrop)) > 0;
      this.product.pages.length > 1 && (EventBus.$emit('showHideLoader', true));


      const keepActivePage = this.activePage;
      for (let y = 1; y < cloneProduct.pages.length; y++) {
        this.activePage = y;
        const oldWidth = parseFloat(this.getCropWidth);
        const oldHeight = parseFloat(this.getCropHeight);
        const widthRatio = parseFloat(newWidth / oldWidth);
        const heightRatio = parseFloat(newHeight / oldHeight);

        cloneProduct.pages[y].width = isCropX ? newWidth + (cloneProduct.XCrop * 2) : newWidth;
        cloneProduct.pages[y].height = isCropY ? newHeight + (cloneProduct.YCrop * 2) : newHeight;

        for (let i = 0; i < cloneProduct.pages[y].objectList.length; i++) {
          if (cloneProduct.pages[y].objectList[i].type === 'image') {
            cloneProduct.pages[y].objectList[i].X *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y *= heightRatio;
            if (cloneProduct.pages[y].objectList[i].Name === 'z-border') {
              cloneProduct.pages[y].objectList[i].scaleX *= widthRatio;
              cloneProduct.pages[y].objectList[i].scaleY *= heightRatio;
            } else {
              cloneProduct.pages[y].objectList[i].Width *= widthRatio;
              cloneProduct.pages[y].objectList[i].Height *= heightRatio;
            }
            if (cloneProduct.pages[y].objectList[i].ImageType === 'SVGImage') {
              const shapeObject = cloneProduct.pages[y].objectList[i];
              shapeObject.SvgProperty.svgScaleX *= widthRatio;
              shapeObject.SvgProperty.svgScaleY *= heightRatio;
              const isTransformStyle = shapeObject.SvgProperty.content.includes(`style="transform-origin: left top; transform: ${shapeObject.SvgProperty.style};"`);
              const isTransformStyleWith0Px = shapeObject.SvgProperty.content.includes(`style="transform-origin: left top 0px; transform: ${shapeObject.SvgProperty.style};"`);
              if (isTransformStyle || isTransformStyleWith0Px) {
                if (isTransformStyleWith0Px) {
                  shapeObject.SvgProperty.content = shapeObject.SvgProperty.content.replace(`style="transform-origin: left top 0px; transform: ${shapeObject.SvgProperty.style};"`, `style="transform-origin: left top; transform: scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY});"`);
                } else {
                  shapeObject.SvgProperty.content = shapeObject.SvgProperty.content.replace(`style="transform-origin: left top; transform: ${shapeObject.SvgProperty.style};"`, `style="transform-origin: left top; transform: scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY});"`);
                }
                shapeObject.SvgProperty.style = `scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY})`;
              }
            }
          }
          if (cloneProduct.pages[y].objectList[i].type === 'shape') {
            cloneProduct.pages[y].objectList[i].X *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y *= heightRatio;
            cloneProduct.pages[y].objectList[i].Width *= widthRatio;
            cloneProduct.pages[y].objectList[i].Height *= heightRatio;
            const shapeObject = cloneProduct.pages[y].objectList[i];
            shapeObject.svgScaleX *= widthRatio;
            shapeObject.svgScaleY *= heightRatio;
            if (document.getElementById(shapeObject.Id) && document.getElementById(shapeObject.Id).querySelector('svg') && (shapeObject.shapeType === 'polygon' || shapeObject.shapeType === 'ellipses')) {
              const shapeElement = document.getElementById(shapeObject.Id).querySelector('svg');
              shapeObject.Width = parseFloat(shapeElement.getAttribute('width')) * shapeObject.svgScaleX;
              shapeObject.Height = parseFloat(shapeElement.getAttribute('height')) * shapeObject.svgScaleY;
            }
          }
          if (cloneProduct.pages[y].objectList[i].type === 'table') {
            this.scaleTableObject(cloneProduct.pages[y].objectList[i], widthRatio, heightRatio);
          }
          if (cloneProduct.pages[y].objectList[i].type === 'text') {
            if (widthRatio == heightRatio) {
              const oldOffsetWidth = (cloneProduct.pages[y].objectList[i].Width * cloneProduct.pages[y].objectList[i].scaleX - cloneProduct.pages[y].objectList[i].Width) / 2;
              const oldOffsetHeight = (cloneProduct.pages[y].objectList[i].Height * cloneProduct.pages[y].objectList[i].scaleY - cloneProduct.pages[y].objectList[i].Height) / 2;

              cloneProduct.pages[y].objectList[i].scaleY *= widthRatio;
              cloneProduct.pages[y].objectList[i].scaleX *= widthRatio;

              cloneProduct.pages[y].objectList[i].X = (cloneProduct.pages[y].objectList[i].X - oldOffsetWidth) * widthRatio;
              cloneProduct.pages[y].objectList[i].Y = (cloneProduct.pages[y].objectList[i].Y - oldOffsetHeight) * heightRatio;

              const newOffsetWidth = (cloneProduct.pages[y].objectList[i].Width * cloneProduct.pages[y].objectList[i].scaleX - cloneProduct.pages[y].objectList[i].Width) / 2;
              const newOffsetHeight = (cloneProduct.pages[y].objectList[i].Height * cloneProduct.pages[y].objectList[i].scaleY - cloneProduct.pages[y].objectList[i].Height) / 2;

              cloneProduct.pages[y].objectList[i].X += newOffsetWidth;
              cloneProduct.pages[y].objectList[i].Y += newOffsetHeight;
            } else {
              cloneProduct.pages[y].objectList[i].X *= widthRatio;
              cloneProduct.pages[y].objectList[i].Y *= heightRatio;
              cloneProduct.pages[y].objectList[i].Width *= widthRatio;
              cloneProduct.pages[y].objectList[i].Height *= heightRatio;

              let element = document.createElement('div');
              element.innerHTML = cloneProduct.pages[y].objectList[i].Value;
              element = element.cloneNode(true);
              if (element) {
                const childList = element.querySelectorAll('SPAN , FONT, li , ul, div');
                const ratioForText = parseFloat((widthRatio * heightRatio));
                if (childList.length) {
                  for (const current of childList) {
                    if (current.getAttribute('style') && current.getAttribute('style').indexOf('font-size:') !== -1) {
                      current.style.fontSize = `${parseFloat(parseFloat(current.style.fontSize) * ratioForText)}px`;
                    }
                  }
                }
                cloneProduct.pages[y].objectList[i].fontSize = parseFloat(cloneProduct.pages[y].objectList[i].fontSize) * ratioForText;
                cloneProduct.pages[y].objectList[i].valuesForLeftPanel.fontSize = cloneProduct.pages[y].objectList[i].fontSize;
                cloneProduct.pages[y].objectList[i].Value = element.outerHTML;
                cloneProduct.pages[y].objectList[i].modifiedHtml = element.outerHTML;
              }
            }
          }
        }


        if (this.product.pages.length > 1) {
          this.product.pages[y] = cloneProduct.pages[y];
          await new Promise(r => setTimeout(r, 1000));
        }
      }
      this.$nextTick(() => {
        EventBus.$emit('showHideLoader', false);
        this.activePage = keepActivePage;
        this.product = cloneProduct;
        this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
        EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
      });
    },
    allPagesShouldBeSame() {
      const tempProduct = _.cloneDeep(this.product);
      const newHeight = tempProduct.pages[0].height;
      const newWidth = tempProduct.pages[0].width;
      const data = {
        newWidth,
        newHeight,
      };
      console.log('Data ', data);
      this.AllProductPagesShouldHaveSameDimensions(data);
    },
    updateVideoAttrInProduct(videoUrl) {
      this.product.videoUrl = videoUrl;
      delete this.product.pdfUrl;
    },
    updateVideoGifAttrInProduct(gifUrl) {
      this.product.gifUrl = gifUrl;
    },
    updateVideoWatermarkAttrInProduct(videoWatermarkUrl) {
      this.product.watermarkVideoUrl = videoWatermarkUrl;
    },
    toggleVideoMood(value) {
      const tempProduct         = this.product;
      tempProduct.isVideo       = value;
      tempProduct.isVideoEditor = value;
      console.log('tempProduct');
      console.log(tempProduct);
      tempProduct.pages.forEach((page, index) => {
        if (!page.animation) {
          tempProduct.pages[index].animation = {
            speed: 1,
            style: 'pageAnimationNone',
            startTime: 0.0,
            duration: 5.0,
            onEnter: false,
            onExit: false,
            timeLineWidth: 140,
          };
        }
      });
      this.product = tempProduct;
    },
    AddNewAudio(audioDetails) {
      const cloneProduct = _.cloneDeep(this.product);
      cloneProduct.audioDetails = audioDetails;
      this.product = cloneProduct;
    },
    updatePageUndoRedoObject() { // unused function
      const self = this;
      this.product.pages.forEach((page, i) => {
        page.objectList.forEach((object, j) => {
          if (object.type == 'pagedetails') {
            self.product.pages[i].objectList[j].animation = {...object.animation};
          }
        });
      });
    },
    calculateFirstScreenStartTime(index) {
      let startTime = 0;
      for (let i = 0; i < index; i++) {
        startTime += parseFloat(this.product.pages[i].animation.duration);
      }
      return startTime;
    },
    calculateSecondScreenTime(index) {
      let startTime = 0;
      for (let i = 0; i <= index; i++) {
        startTime += parseFloat(this.product.pages[i].animation.duration);
      }
      return startTime;
    },
    calculateScreenDuration(index) {
      return parseFloat(this.product.pages[index].animation.duration);
    },
    updateProductTransitionObjects() {
      let firstScreenStartTime = 0;
      let secondScreenStartTime = 0;
      let firstScreenDuration = 0;
      let secondScreenDuration = 0;
      if (this.product.transitions) {
        for (let i = 0; i < this.product.transitions.length; i++) {
          firstScreenStartTime = this.calculateFirstScreenStartTime(i);
          secondScreenStartTime = this.calculateSecondScreenTime(i);
          firstScreenDuration = this.calculateScreenDuration(i);
          secondScreenDuration = this.calculateScreenDuration(i + 1);
          this.product.transitions[i].firstScreenStartTime = firstScreenStartTime;
          this.product.transitions[i].firstScreenDuration = firstScreenDuration;
          this.product.transitions[i].secondScreenStartTime = secondScreenStartTime;
          this.product.transitions[i].secondScreenDuration = secondScreenDuration;
        }
      }
    },
    getLongestDuration(objects) {
      let longestDurationObject = null;
      let longestDuration = 0;
      for (const obj of objects) {
        if (obj.videoDetails.endTime - obj.videoDetails.startTime > longestDuration) {
          longestDuration = obj.videoDetails.endTime - obj.videoDetails.startTime;
          longestDurationObject = obj;
        }
      }
      return longestDurationObject;
    },
    updatePagesTransition(transition) {
      const item = transition && transition[0];
      const activePageIndex = item && item.pageIndex != null
          ? item.pageIndex
          : this.$store.getters['activeProduct/getPageAnimationIndex'];
      if (activePageIndex < 0 || !item) {
        return;
      }
      if (!Array.isArray(this.product.transitions)) {
        this.$set(this.product, 'transitions', []);
      }
      this.$set(this.product.transitions, activePageIndex, _.cloneDeep(item));
      this.syncVideoModeWithProduct();
    },
    addNewPageTransitionObject(transition) {
      if (this.product.transitions) {
        this.product.transitions.push(_.cloneDeep(transition[0]));
      } else {
        this.product.transitions = _.cloneDeep(transition);
      }
    },
    filterObjectsByType(objects) {
      const videoObjects = objects.filter(obj => obj.type === 'video');
      return videoObjects.length > 0 ? videoObjects : null;
    },
    updateActivePageDuration() {
      // EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, 'called by video object trimming');
      const cloneProduct = _.cloneDeep(this.product);
      // if (this.activeObject) { // ommitting check for testing
      const videoArray = this.filterObjectsByType(cloneProduct.pages[this.activePage].objectList);

      if (videoArray) {
        const longestDurationObject = this.getLongestDuration(videoArray);
        const durationOfPage = (longestDurationObject.videoDetails.endTime - longestDurationObject.videoDetails.startTime);
        cloneProduct.pages[this.activePage].animation.duration = parseFloat(durationOfPage) > 2 ? durationOfPage : 2;
        const productDuration = parseFloat(cloneProduct.pages[this.activePage].animation.duration);
        cloneProduct.pages[this.activePage].animation.timeLineWidth = productDuration * 28;
        this.product = cloneProduct;
        this.activeObject = null;
        this.updateProductTransitionObjects();
      }
      // }
    },
    updateProductPageDuration(duration) {
      duration = parseFloat(duration);
      const cloneProduct = _.cloneDeep(this.product);
      cloneProduct.pages[this.activePage].animation.duration = duration.toFixed(2);
      const productDuration = parseFloat(cloneProduct.pages[this.activePage].animation.duration);
      cloneProduct.pages[this.activePage].animation.timeLineWidth = productDuration * 30;
      this.product = cloneProduct;
      this.activeObject = null;
      this.updateProductTransitionObjects();
    },
    applyPageTransition(style, index, speed) {
      const page = this.product && this.product.pages && this.product.pages[index];
      if (!page) {
        return;
      }
      if (!page.animation) {
        this.$set(page, 'animation', {
          speed: 50, style: 'pageAnimationNone', startTime: 0, duration: 5, onEnter: false, onExit: false, timeLineWidth: 140,
        });
      }
      this.$set(page.animation, 'style', style);
      this.$set(page.animation, 'speed', speed);
    },
    setDefaultProduct() {
      this.product = _.cloneDeep(this.$store.getters.getSelectedProduct);
    },
    async onReplaceHighResResources() {
      await this.replaceResourcesWithHighResolutionResourceInProduct();
      this.updateProductColorList();
    },
    updateTextObjectValue({value, index, fontSize} = {}) {
      if (this.product && this.product.pages[this.activePage] && this.product.pages[this.activePage].objectList[index]) {
        this.product.pages[this.activePage].objectList[index].Value = value;
        this.product.pages[this.activePage].objectList[index].modifiedHtml = value;
        if (typeof fontSize !== 'undefined') {
          const parsedFontSize = parseFloat(fontSize);
          if (!Number.isNaN(parsedFontSize)) {
            this.product.pages[this.activePage].objectList[index].fontSize = parsedFontSize;
            if (this.product.pages[this.activePage].objectList[index].valuesForLeftPanel) {
              this.product.pages[this.activePage].objectList[index].valuesForLeftPanel.fontSize = parsedFontSize;
            }
          }
        }
        // this.product.pages[this.activePage].objectList[index].unCurvedHtml = value;
      }
    },

    scaleTableObject(table, widthRatio, heightRatio) {
      const scalarRatio = Math.sqrt(widthRatio * heightRatio);

      table.X *= widthRatio;
      table.Y *= heightRatio;

      (table.cols || []).forEach((col) => {
        col.width *= widthRatio;
      });
      (table.rows || []).forEach((row) => {
        row.height *= heightRatio;
      });

      table.Width = (table.cols || []).reduce((sum, col) => sum + (col.width || 0), 0);
      table.Height = (table.rows || []).reduce((sum, row) => sum + (row.height || 0), 0);

      // Border weights stay 1-20 slider units; the drawn stroke tracks pageScale.
      this.$set(table, 'pageScale', (parseFloat(table.pageScale) || 1) * scalarRatio);
      this.$set(table, 'contentScale', getTableContentScale(table) * scalarRatio);

      (table.cells || []).forEach((row) => {
        (row || []).forEach((cell) => {
          if (cell && cell.fontSize) {
            cell.fontSize *= scalarRatio;
          }
        });
      });
    },
    changeProductSizeFromDropDown(object) {
      this.onAddIntoPageWiseUndoRedoArray('called by size change');
      const newWidth = object.name !== 'Common' ? parseInt(object.size.split('x')[0], 10) : parseInt(this.defaultProductWidth, 10);
      const newHeight = object.name !== 'Common' ? parseInt(object.size.split('x')[1], 10) : parseInt(this.defaultProductHeight, 10);
      const data = {
        label: 'none',
        newWidth,
        newHeight,
      };
      if (parseInt(newWidth, 10) !== parseInt(this.getProductSizePixel.width, 10) || parseInt(newHeight, 10) !== parseInt(this.getProductSizePixel.height, 10)) {
        this.onChangeProductSizeAfterResize(data);
      }
    },
    async onChangeProductSizeAfterResize(data) {
      if ((data.newWidth && parseInt(data.newWidth, 10) < 1) || (data.newHeight && parseInt(data.newHeight, 10) < 1)) {
        return;
      }

      const cloneProduct = _.cloneDeep(this.product);

      const oldWidth = parseFloat(this.getCropWidth);
      const oldHeight = parseFloat(this.getCropHeight);

      let newWidth = data.newWidth ? parseFloat(data.newWidth) : oldWidth;
      let newHeight = data.newHeight ? parseFloat(data.newHeight) : oldHeight;

      const isOldNewWidthEqual = Math.round(newWidth) === Math.round(oldWidth);
      const isOldNewHeightEqual = Math.round(newHeight) === Math.round(oldHeight);

      if (!cloneProduct.AllowCropping && isOldNewWidthEqual && isOldNewHeightEqual) {
        return;
      }

      const isCropX = Math.round(parseFloat(this.product.XCrop)) > 0;
      const isCropY = Math.round(parseFloat(this.product.YCrop)) > 0;
      const isCropProduct = (isCropX && isCropY);
      const isWidthEqual = ((!data.newWidth && Math.round(newWidth) === Math.round(oldWidth)) || (data.newWidth && Math.round(data.newWidth) === Math.round(oldWidth)));
      const isHeightEqual = ((!data.newHeight && Math.round(newHeight) === Math.round(oldHeight)) || (data.newHeight && Math.round(data.newHeight) === Math.round(oldHeight)));
      const isCropWidthEqual = Math.round(data.newWidth) === Math.round(cloneProduct.WidthCrop);
      const isCropHeightEqual = Math.round(data.newHeight) === Math.round(cloneProduct.HeightCrop);

      if (isCropProduct && isWidthEqual && isHeightEqual) {
        return;
      }

      if (isCropProduct && ((data.newWidth && isCropWidthEqual && !data.newHeight && isOldNewHeightEqual) || (data.newHeight && isCropHeightEqual && !data.newWidth && isOldNewWidthEqual))) {
        return;
      }

      this.product.pages.length > 1 && (EventBus.$emit('showHideLoader', true));

      if ((this.isProductSizeRatio) && data.label !== 'none') {
        if (data.label === 'Width') {
          newHeight = oldHeight * parseFloat(newWidth / oldWidth);
        } else if (data.label === 'Height') {
          newWidth = oldWidth * parseFloat(newHeight / oldHeight);
        }
      }
      const widthRatio = parseFloat(newWidth / oldWidth);
      const heightRatio = parseFloat(newHeight / oldHeight);

      cloneProduct.XCrop && (cloneProduct.XCrop *= widthRatio);
      cloneProduct.YCrop && (cloneProduct.YCrop *= heightRatio);

      cloneProduct.WidthCrop && isCropX && (cloneProduct.WidthCrop = data.newWidth ? data.newWidth : newWidth);
      cloneProduct.HeightCrop && isCropY && (cloneProduct.HeightCrop = data.newHeight ? data.newHeight : newHeight);

      const keepActivePage = this.activePage;
      for (let y = 0; y < cloneProduct.pages.length; y++) {
        if (!this.$store.getters['activeProduct/getIsVideoMoodOn']) {
          if (this.getIsProductCrop.isShowCrop === false && y != this.activePage) {
            continue;
          }
        }

        cloneProduct.pages[y].width = isCropX ? newWidth + (cloneProduct.XCrop * 2) : newWidth;
        cloneProduct.pages[y].height = isCropY ? newHeight + (cloneProduct.YCrop * 2) : newHeight;

        for (let i = 0; i < cloneProduct.pages[y].objectList.length; i++) {
          const isFDICQEQ = cloneProduct.pages[y].objectList[i].ImageType && (cloneProduct.pages[y].objectList[i].ImageType.indexOf('FDICText') > -1 || cloneProduct.pages[y].objectList[i].ImageType.indexOf('FDICLogo') > -1);
          if (cloneProduct.pages[y].objectList[i].type === 'image' && !isFDICQEQ) {
            cloneProduct.pages[y].objectList[i].X *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y *= heightRatio;
            if (cloneProduct.pages[y].objectList[i].Name === 'z-border') {
              cloneProduct.pages[y].objectList[i].scaleX *= widthRatio;
              cloneProduct.pages[y].objectList[i].scaleY *= heightRatio;
            } else {
              cloneProduct.pages[y].objectList[i].Width *= widthRatio;
              cloneProduct.pages[y].objectList[i].Height *= heightRatio;
            }
            if (cloneProduct.pages[y].objectList[i].ImageType === 'SVGImage') {
              const shapeObject = cloneProduct.pages[y].objectList[i];
              shapeObject.SvgProperty.svgScaleX *= widthRatio;
              shapeObject.SvgProperty.svgScaleY *= heightRatio;
              const isTransformStyle = shapeObject.SvgProperty.content.includes(`style="transform-origin: left top; transform: ${shapeObject.SvgProperty.style};"`);
              const isTransformStyleWith0Px = shapeObject.SvgProperty.content.includes(`style="transform-origin: left top 0px; transform: ${shapeObject.SvgProperty.style};"`);
              if (isTransformStyle || isTransformStyleWith0Px) {
                if (isTransformStyleWith0Px) {
                  shapeObject.SvgProperty.content = shapeObject.SvgProperty.content.replace(`style="transform-origin: left top 0px; transform: ${shapeObject.SvgProperty.style};"`, `style="transform-origin: left top; transform: scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY});"`);
                } else {
                  shapeObject.SvgProperty.content = shapeObject.SvgProperty.content.replace(`style="transform-origin: left top; transform: ${shapeObject.SvgProperty.style};"`, `style="transform-origin: left top; transform: scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY});"`);
                }
                shapeObject.SvgProperty.style = `scale(${shapeObject.SvgProperty.svgScaleX}, ${shapeObject.SvgProperty.svgScaleY})`;
              }
            }
          }
          if (isFDICQEQ) {
            cloneProduct.pages[y].objectList[i].X *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y *= heightRatio;
          }
          if (cloneProduct.pages[y].objectList[i].type === 'shape') {
            cloneProduct.pages[y].objectList[i].X *= widthRatio;
            cloneProduct.pages[y].objectList[i].Y *= heightRatio;
            cloneProduct.pages[y].objectList[i].Width *= widthRatio;
            cloneProduct.pages[y].objectList[i].Height *= heightRatio;
            const shapeObject = cloneProduct.pages[y].objectList[i];
            shapeObject.svgScaleX *= widthRatio;
            shapeObject.svgScaleY *= heightRatio;
            if (document.getElementById(shapeObject.Id) && document.getElementById(shapeObject.Id).querySelector('svg') && (shapeObject.shapeType === 'polygon' || shapeObject.shapeType === 'ellipses')) {
              const shapeElement = document.getElementById(shapeObject.Id).querySelector('svg');
              shapeObject.Width = parseFloat(shapeElement.getAttribute('width')) * shapeObject.svgScaleX;
              shapeObject.Height = parseFloat(shapeElement.getAttribute('height')) * shapeObject.svgScaleY;
            }
          }
          if (cloneProduct.pages[y].objectList[i].type === 'table') {
            this.scaleTableObject(cloneProduct.pages[y].objectList[i], widthRatio, heightRatio);
          }
          if (cloneProduct.pages[y].objectList[i].type === 'text') {
            y;
            if (widthRatio == heightRatio) {
              const oldOffsetWidth = (cloneProduct.pages[y].objectList[i].Width * cloneProduct.pages[y].objectList[i].scaleX - cloneProduct.pages[y].objectList[i].Width) / 2;
              const oldOffsetHeight = (cloneProduct.pages[y].objectList[i].Height * cloneProduct.pages[y].objectList[i].scaleY - cloneProduct.pages[y].objectList[i].Height) / 2;

              cloneProduct.pages[y].objectList[i].scaleY *= widthRatio;
              cloneProduct.pages[y].objectList[i].scaleX *= widthRatio;

              cloneProduct.pages[y].objectList[i].X = (cloneProduct.pages[y].objectList[i].X - oldOffsetWidth) * widthRatio;
              cloneProduct.pages[y].objectList[i].Y = (cloneProduct.pages[y].objectList[i].Y - oldOffsetHeight) * heightRatio;

              const newOffsetWidth = (cloneProduct.pages[y].objectList[i].Width * cloneProduct.pages[y].objectList[i].scaleX - cloneProduct.pages[y].objectList[i].Width) / 2;
              const newOffsetHeight = (cloneProduct.pages[y].objectList[i].Height * cloneProduct.pages[y].objectList[i].scaleY - cloneProduct.pages[y].objectList[i].Height) / 2;

              cloneProduct.pages[y].objectList[i].X += newOffsetWidth;
              cloneProduct.pages[y].objectList[i].Y += newOffsetHeight;
            } else {
              cloneProduct.pages[y].objectList[i].X *= widthRatio;
              cloneProduct.pages[y].objectList[i].Y *= heightRatio;
              cloneProduct.pages[y].objectList[i].Width *= widthRatio;
              cloneProduct.pages[y].objectList[i].Height *= heightRatio;

              let element = document.createElement('div');
              element.innerHTML = cloneProduct.pages[y].objectList[i].Value;
              element = element.cloneNode(true);
              if (element) {
                const childList = element.querySelectorAll('SPAN , FONT, li , ul, div');
                const ratioForText = parseFloat((widthRatio * heightRatio));
                if (childList.length) {
                  for (const current of childList) {
                    if (current.getAttribute('style') && current.getAttribute('style').indexOf('font-size:') !== -1) {
                      current.style.fontSize = `${parseFloat(parseFloat(current.style.fontSize) * ratioForText)}px`;
                    }
                  }
                }
                cloneProduct.pages[y].objectList[i].fontSize = parseFloat(cloneProduct.pages[y].objectList[i].fontSize) * ratioForText;
                cloneProduct.pages[y].objectList[i].valuesForLeftPanel.fontSize = cloneProduct.pages[y].objectList[i].fontSize;
                cloneProduct.pages[y].objectList[i].Value = element.outerHTML;
                cloneProduct.pages[y].objectList[i].modifiedHtml = element.outerHTML;
              }
            }
          }
        }


        if (this.product.pages.length > 1) {
          this.product.pages[y] = cloneProduct.pages[y];
          this.activePage = y;
          await new Promise(r => setTimeout(r, 1000));
        }
      }
      this.$nextTick(() => {
        EventBus.$emit('showHideLoader', false);
        this.activePage = keepActivePage;
        this.product = cloneProduct;
        /*
         * resizing all objects takes time
         * wait for sometime to save to undo-redo array
         */

        setTimeout(() => {
          this.onAddIntoPageWiseUndoRedoArray('called by size change');
        }, 1000);
      });
    },
    openDetailSection() {
      this.DetailSection.isOpen = !this.DetailSection.isOpen;
      this.DetailSection.isOpen && EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onClearSelection);
    },
    openShapeSection() {
      this.isOpenShapeSection = !this.isOpenShapeSection;
      this.isOpenShapeSection && EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.onClearSelection);
    },
    closeDetailsection() {
      this.DetailSection.isOpen = false;
    },

    async extractColorFromProduct() {
      const pages = this.product.pages;
      const colorList = [];
      const addColor = (color) => {
        const normalized = this.normalizeProductColor(color);
        normalized && !colorList.includes(normalized) && colorList.push(normalized);
      };
      for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
        const {objectList} = pages[pageIndex];
        for (let objectIndex = 0; objectIndex < objectList.length; objectIndex++) {
          const object = objectList[objectIndex];
          switch (object.type) {
            case 'text':
              addColor(object.color);
              this.extractColorFromText(object.modifiedHtml).forEach(addColor);
              break;
            case 'image':
              if (object.ImageType == 'SVGImage') {
                object.SvgProperty && addColor(object.SvgProperty.DefaultColor);
                break;
              }
              if (object.ImageType == 'WhiteboxLogo' && object.DefaultImageUrl && object.DefaultImageUrl.split(/[#?]/)[0].trim().endsWith('.svg')) {
                const svgColors = await this.extractColorFromSvg(object.DefaultImageUrl.trim());
                svgColors.length < 10 && svgColors.forEach(addColor);
              }
              break;
            case 'shape':
              addColor(object.DefaultColor);
          }
        }
      }
      return colorList;
    },
    extractColorFromText(htmlString) {
      const divElement = document.createElement('div');
      divElement.innerHTML = htmlString || '';

      if (!divElement.firstElementChild) {
        return [];
      }
      const spanList = divElement.firstElementChild.querySelectorAll('span, font');
      return Array.prototype.map.call(spanList, span => span.style.color);
    },
    // Canonical "rgba(r,g,b,a)" so the same colour written as hex / rgb() / rgba() is listed once
    normalizeProductColor(color) {
      if (typeof color !== 'string' || !color.trim() || !CSS.supports('color', color)) {
        return null;
      }
      this.colorNormalizerCtx || (this.colorNormalizerCtx = document.createElement('canvas').getContext('2d'));
      this.colorNormalizerCtx.fillStyle = color;
      // the canvas serializes as "#rrggbb" when opaque, "rgba(r, g, b, a)" otherwise
      const serialized = this.colorNormalizerCtx.fillStyle;
      if (serialized.startsWith('#')) {
        return `rgba(${hexToRgb(serialized).slice(4, -1)},1)`;
      }
      const rgba = serialized.replaceAll(' ', '');
      return rgba.endsWith(',0)') ? null : rgba; // skip fully transparent
    },
    async extractColorFromSvg(url) {
      try {
        const response = await axios.post('https://pdf-processing.bankmarketingcenter.com/node/svgcolor', {
          'svg-type': 'url',
          svg: url,
        });
        const {data} = response;
        return data.code == 200 && data.colorList.success ? data.colorList.colors : [];
      } catch (e) {
        console.error(e);
        return [];
      }
    },
    changeProductSize(unit) {
      this.product.IsInch = unit == 'Inches';
    },
    closeModalsDefault() {
      EventBus.$emit('closeOpenedModals', this.modalTruthy);
    },
    closeModals(e) {
      EventBus.$emit('modalsCloser', this.checkModal);
    },

    onDeleteProductPage() {
      if (this.product.pages.length !== 1) {
        this.deletePageDataFromPageWiseUndoRedoArray();
        this.product.pages.splice(this.activePage, 1);
        this.product.transitions.splice(this.activePage - 1, 1);
        this.productPagesLength = this.product.pages.length;
        const tempActivePage = this.activePage;
        this.activePage = null;
        this.activePage = tempActivePage;
        this.activePage > 0 && (--this.activePage);
        this.updateProductTransitionObjects();
      }
    },
    onDuplicateProductPage() {
      if (this.product.pages.length > 14) {
        alert('page limit exceeded');
        return;
      }
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.SET_TARGET_EMPTY);
      setTimeout(() => {
        const tempDuplicateProductPage = _.cloneDeep(this.product.pages[this.activePage]);
        tempDuplicateProductPage.objectList.forEach((object) => {
          object.Id = uuidv4();
          object.isSelected = false;
          object.editor = null;
          object.PageNo = this.activePage + 1;
          object.type == 'text' && object.modifiedHtml !== object.Value && (object.Value = object.modifiedHtml);
        });
        this.product.pages.push(tempDuplicateProductPage);
        const transition = [
          {
            name: 'transitionNone',
            speed: 50,
            time: 5.0,
            firstScreenStartTime: 0,
            firstScreenDuration: 5,
            secondScreenStartTime: 5,
            secondScreenDuration: 5,
          }];
        this.addNewPageTransitionObject(transition);
        this.updateProductTransitionObjects();
        this.productPagesLength = this.product.pages.length;
        this.duplicatePageInPageWiseUndoRedo();
      }, 10);
    },
    onCreateNewProductPage() {
      if (this.product.pages.length > 14) {
        alert('page limit exceeded');
        return;
      }
      const tempCreateNewProductPage = _.cloneDeep(this.product.pages[this.activePage]);
      tempCreateNewProductPage.objectList = [];
      tempCreateNewProductPage.baseImage = '';// https://trello.com/c/SQzYEgbz/682-adding-new-page-copying-background-image
      tempCreateNewProductPage.animation = {
        speed: 1,
        style: 'pageAnimationNone',
        startTime: 0.0,
        duration: 5.0,
        onEnter: false,
        onExit: false,
        timeLineWidth: 140,
      };
      let tempElementArrayCount = this.product.pages.push(tempCreateNewProductPage);
      (tempElementArrayCount--) && (this.activePage = tempElementArrayCount);
      this.productPagesLength = this.product.pages.length;
      const transition = [
        {
          name: 'transitionNone',
          speed: 50,
          time: 5.0,
          firstScreenStartTime: 0,
          firstScreenDuration: 0,
          secondScreenStartTime: 0,
          secondScreenDuration: 5,
        }];
      this.addNewPageTransitionObject(transition);
      this.updateProductTransitionObjects();
      this.$store.commit('updateSelectedProduct', _.cloneDeep(this.product));
      this.addNewPageInPageWiseUndoRedo();
    },
    onChangeProductPage(pageindex) {
      this.activePage = pageindex;
    },
    loadAllAddressBoxes(productId) {
      console.log('loadAllAddressBoxes');
      const baseURL = this.$store.getters.getBaseUrl;
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url = `${baseURL}/web_service.aspx?method=GetBankAllAddressBoxesNewEditor&domainURL=https://${domainUrl}.com/&bankId=${this.$store.getters.getBankId}&productId=${productId}`;


      const oReq = new XMLHttpRequest();
      const _this = this;
      oReq.addEventListener('load', async (Response) => {
        const xmlParser = new DOMParser();
        const convertedDoM = xmlParser.parseFromString(Response.target.response, 'text/xml');
        const address = JSON.parse(convertedDoM.getElementsByTagName('GetBankAllAddressBoxesNewEditorResult')[0].innerHTML);
        let addressArr = address.BanksAddresses ? address.BanksAddresses : [];
        const equalHousingLogos = address.EqualHousingLogos ? address.EqualHousingLogos : [];
        const ncuaLogos = address.NcuaLogos ? address.NcuaLogos : [];
        const fdicLogos = address.FdicLogos ? address.FdicLogos : [];
        addressArr = addressArr.filter(Boolean);
        addressArr = await Promise.all(addressArr.map(async (item) => {
          try {
            const res = await axios.post(
                `https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${item.HighResImagePath}&productId=${productId}`,
            );
            const isWhite = await extractSvgColors(res.data.svg);
            return {...item, DefaultImagePath: res.data.svg, isWhite};
          } catch (e) {
            console.error(e);
            return item;
          }
        }));

        equalHousingLogos.forEach(async (item) => {
          await axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${item.PdfUrl}&productId=${productId}`)
              .then((res) => {
                item.DefaultImagePath = res.data.svg;
              })
              .catch((e) => {
                console.error(e);
              });
        });
        fdicLogos.forEach(async (item) => {
          await axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${item.PdfUrl}&productId=${productId}`)
              .then((res) => {
                item.DefaultImagePath = res.data.svg;
              })
              .catch((e) => {
                console.error(e);
              });
        });
        ncuaLogos.forEach(async (item) => {
          await axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${item.PdfUrl}&productId=${productId}`)
              .then((res) => {
                item.DefaultImagePath = res.data.svg;
              })
              .catch((e) => {
                console.error(e);
              });
        });
        setTimeout(() => {
          const adBoxes = addressArr.filter(item => item.DefaultImagePath); // remove empty entries
          _this.ProductAddressBoxes = adBoxes;
          this.$store.commit('updateAddressBoxes', adBoxes);
          this.$store.commit('updateFdicLogos', fdicLogos);
          this.$store.commit('updateNcuaLogos', ncuaLogos);
          this.$store.commit('updateHousingLogos', equalHousingLogos);
        }, 0);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadSvgShapes() {
      // /https://wysiwyg.bankmarketingcenter.com/web_service.aspx?method=GetFontsByBank&domainURL=https://www.bankmarketingcenter.com/&bankId=fde5ed9d-816f-43fd-89f3-97a542947193&productId=d07a80b7-bf50-464e-bfe2-604d48849d83

      //
      // const url = new URL('https://dev2.wysiwyg.bankmarketingcenter.com/web_service.aspx?');
      // url.searchParams.set('method', 'GetSvgShapes');
      // url.searchParams.set('domainURL', 'https://www.bankmarketingcenter.com/');
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;

      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetSvgShapesByBank&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/`;

      const oReq = new XMLHttpRequest();
      const _this = this;
      oReq.addEventListener('load', (Response) => {
        const parser = new DOMParser();
        const xmlParsed = parser.parseFromString(Response.target.response, 'text/xml');
        let svgCollection = xmlParsed.getElementsByTagName('GetSvgShapesByBankResult');
        svgCollection[0] && (svgCollection = svgCollection[0].innerHTML);
        const parse = JSON.parse(svgCollection);
        this.$store.commit('updataProductSvg', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadSvgShapeCategories() {
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SearchSvgShapeCategory&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        console.error('loading SVG categories', Response);
        const parser = new DOMParser();
        const xmlParsed = parser.parseFromString(Response.target.response, 'text/xml');
        let svgCollection = xmlParsed.getElementsByTagName('SearchSvgShapeCategoryResult');
        svgCollection[0] && (svgCollection = svgCollection[0].innerHTML);
        const parse = JSON.parse(svgCollection);
        this.$store.commit('updateSVGCategories', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.log('Error in loading Shapes Categories', e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadUserInfo() {
      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx`;
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;

      const oReq = new XMLHttpRequest();

      oReq.open('POST', url, true);

      oReq.setRequestHeader(
          'Content-Type',
          'application/x-www-form-urlencoded',
      );

      const getTagText = (parent, tag) => {
        const node = parent && parent.getElementsByTagName(tag)[0];
        return (node && node.textContent) || '';
      };

      oReq.onload = () => {
        const xml = oReq.responseText;
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xml, 'text/xml');
        const result = xmlDoc.getElementsByTagName('GetUserInfoResult')[0];

        if (!result) {
          console.log('Error in loading user info', xml);
          return;
        }

        const userInfo = {
          id: getTagText(result, 'Id'),
          username: getTagText(result, 'Username'),
          fullname: getTagText(result, 'Fullname'),
          bankname: getTagText(result, 'Bankname'),
          title: getTagText(result, 'Title'),
          address: getTagText(result, 'Address'),
          city: getTagText(result, 'City'),
          state: getTagText(result, 'State'),
          zip: getTagText(result, 'Zip'),
          phone: getTagText(result, 'Phone'),
          fax: getTagText(result, 'Fax'),
          email: getTagText(result, 'Email'),
        };
        console.log('userInfo', userInfo);
        this.$store.commit('updateUserInfo', userInfo);
        this.userInfo = userInfo;
      };

      oReq.onerror = function (e) {
        console.log('Network error', e);
      };

      const payload = 'method=userInfo'
          + `&userId=${encodeURIComponent(this.$store.getters.getUserId)}`
          + `&domainURL=${encodeURIComponent(`https://${domainUrl}.com/`)}`;

      oReq.send(payload);
    },
    loadFontsByBank(productId) {
      const urlSearchPart = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetFontsByBankIdIncludingUserFavorites&domainURL=https://${domainUrl}.com/&bankId=${this.$store.getters.getBankId}&productId=${productId}&userId=${userId}`;


      const oReq = new XMLHttpRequest();
      const _this = this;
      oReq.addEventListener('load', (Response) => {
        const xmlParser = new DOMParser();
        const convertedDoM = xmlParser.parseFromString(Response.target.response, 'text/xml');
        const fontsResult = convertedDoM.getElementsByTagName('FontInfo');
        let jsonFonts = [];
        console.log(fontsResult);
        for (let i = 0; i < fontsResult.length; i++) {
          const item = fontsResult[i];
          try {
            const jsonFontObj = {
              name: item.getElementsByTagName('Name')[0].textContent,
              path: item.getElementsByTagName('VirtualPath')[0].textContent,
              isFavourite: JSON.parse(item.getElementsByTagName('IsFavourite')[0].textContent),
              id: item.getElementsByTagName('Id')[0].textContent,
            };
            jsonFonts.push(jsonFontObj);
          } catch (e) {
            console.log('following item fail', e);
          }
        }
        jsonFonts = [...jsonFonts.reduce((map, obj) => map.set(obj.name, obj), new Map()).values()];
        jsonFonts.sort((a, b) => {
          if (a.isFavourite) {
            return -1;
          }
          if (b.isFavourite) {
            return 1;
          }
          return 0;
        });
        this.$store.commit('setproductfontarray', jsonFonts);
      });
      oReq.addEventListener('error', (e) => {
        this.loadFonts(''); // if the font api data loading is fail then the local font load
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    fontFamilyLoad(jsonFonts) {
      jsonFonts = jsonFonts.filter((value, index) => jsonFonts.indexOf(value) === index);
      const observers = [];
      jsonFonts.forEach((cur) => {
        const obs = new FontFaceObserver(cur);
        observers.push(obs.load());
      });
      Promise.all(observers)
          .then((fonts) => {
            fonts.forEach(() => {
            });
          })
          .catch((err) => {
            console.warn('Some critical font are not available:', err);
          });
    },
    async getFavouriteSizes() {
      const urlSearchPart = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;

      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetUserFavoriteSizes&domainURL=https://${domainUrl}.com/&userId=${userId}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        const parser = new DOMParser();
        const xmlParsed = parser.parseFromString(Response.target.response, 'text/xml');
        const favouriteSizeResult = xmlParsed.querySelector('GetUserFavoriteSizesResult');
        const parse = (favouriteSizeResult && favouriteSizeResult.textContent.length > 0) ? JSON.parse(favouriteSizeResult.textContent) : [];
        this.$store.commit('updateFavouriteSizes', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    addFavouriteSizeToAPI(data) {

    },

    deleteFavouriteSize(id) {
      const urlSearchPart = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;

      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=DeleteUserFavoriteSize&domainURL=https://${domainUrl}.com/&userId=${userId}&sizeId=${id}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        const parser = new DOMParser();
        const xmlParsed = parser.parseFromString(Response.target.response, 'text/xml');
        let favouriteSizeResult = xmlParsed.getElementsByTagName('DeleteUserFavoriteSizeResult');
        favouriteSizeResult[0] && (favouriteSizeResult = favouriteSizeResult[0].innerHTML);
        const parse = JSON.parse(favouriteSizeResult);
        this.$store.commit('updateFavouriteSizes', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadPmsColorNewInfo(product, productXML = null) {
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetPmsColorNewInfo&domainURL=https://${domainUrl}.com/&bankId=${this.$store.getters.getBankId}&productId=${product.Id}`;


      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', async (Response) => {
        const xmlParser = new DOMParser();
        const convertedDoM = xmlParser.parseFromString(Response.target.response, 'text/xml');
        const AllNewPmsColorsChild = convertedDoM.getElementsByTagName('AllNewPmsColors')[0].getElementsByTagName('PmsColorNew');
        const yourColors = convertedDoM.getElementsByTagName('BankNewPmsColors')[0].getElementsByTagName('PmsColorNew');
        const yourColorArray = [];
        if (yourColors) {
          for (const color of yourColors) {
            yourColorArray.push(color.getElementsByTagName('DisplayColorTextRGB')[0].innerHTML);
          }
          this.$store.commit('setYourColor', yourColorArray);
        }

        const temArray = [];
        for (const element of AllNewPmsColorsChild) {
          const tempObj = {};
          tempObj.Id = element.getElementsByTagName('Id')[0].innerHTML;
          tempObj.Name = element.getElementsByTagName('Name')[0].innerHTML;
          tempObj.NumberName = element.getElementsByTagName('NumberName')[0].innerHTML;
          tempObj.IsCustom = element.getElementsByTagName('IsCustom')[0].innerHTML;
          tempObj.Ordering = element.getElementsByTagName('Ordering')[0].innerHTML;
          tempObj.DisplayColorTextCMYK = element.getElementsByTagName('DisplayColorTextCMYK')[0].innerHTML;
          tempObj.DisplayColorTextCMYKHex = element.getElementsByTagName('DisplayColorTextCMYKHex')[0].innerHTML;
          tempObj.DisplayColorTextRGB = element.getElementsByTagName('DisplayColorTextRGB')[0].innerHTML;
          temArray.push(tempObj);
        }
        this.$store.commit('setAllNewPmsColors', temArray);
        productXML && (await this.parseProductObject(productXML, product));
        productXML && (this.parseProductProperties(productXML));
      });
      oReq.addEventListener('error', async (e) => {
        productXML && (await this.parseProductObject(productXML, product));
        productXML && (this.parseProductProperties(productXML, product));
      });
      oReq.open('GET', url);
      oReq.send();
    },
    deSelectActiveObject() {
      if (this.activeObject !== null) {
        this.activeObject = null;
      }
    },
    changeProductAllowCropping(allowCropping) {
      this.product.AllowCropping = allowCropping;
      this.$nextTick(() => {
        const resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      });
    },
    onToggleProductSizeRatioFlag() {
      this.isProductSizeRatio = !this.isProductSizeRatio;
    },
    onChangeProductName(newName) {
      const target = newName === 'reset' ? this.defaultProductName : newName;
      // let cloneProduct = _.cloneDeep(this.product);
      // cloneProduct.Name = newName;
      this.product.Name = target;
    },
    // onChangeProductSizeAfterResize(data){
    //   let cloneProduct=_.cloneDeep(this.product)
    //   let newValue=this.product.IsInch ? parseFloat(data.value)/0.013888888888888888 : parseFloat(data.value)
    //   let cropValue=data.label==='Width' ? parseInt(cloneProduct.XCrop)*2 : data.label==='Height' ? parseInt(cloneProduct.YCrop)*2 : 0
    //   let oldValue=this.getProductSizePixel[data.label.toLowerCase()]+cropValue
    //   let ratio=newValue/oldValue
    //   for(let y=0;y<cloneProduct.pages.length;y++){
    //     for(let i=0 ; i<cloneProduct.pages[y].objectList.length;i++){
    //       cloneProduct.pages[y][data.label.toLowerCase()]=newValue
    //       if(data.label==='Width'){
    //         cloneProduct.XCrop=parseInt(parseInt(cloneProduct.XCrop)*ratio)
    //         // cloneProduct.WidthCrop=parseInt(parseInt(cloneProduct.WidthCrop)*ratio)
    //       }
    //       else if(data.label==='Height'){
    //         cloneProduct.YCrop=parseInt(parseInt(cloneProduct.YCrop)*ratio)
    //         // cloneProduct.HeightCrop=parseInt(parseInt(cloneProduct.HeightCrop)*ratio)
    //       }
    //       cloneProduct.pages[y].objectList[i][data.label]*=ratio
    //       data.label=== 'Width' && (cloneProduct.pages[y].objectList[i].X*=ratio)
    //       data.label=== 'Height' && (cloneProduct.pages[y].objectList[i].Y*=ratio)
    //       if(cloneProduct.pages[y].objectList[i].type==='text'){
    //         let element=document.createElement("div")
    //         element.innerHTML=cloneProduct.pages[y].objectList[i].Value
    //         element=element.firstElementChild
    //         element=element.cloneNode(true)
    //         if (element){
    //           let childList=element.querySelectorAll('SPAN , FONT')
    //           if(childList.length){
    //             for(let i=0 ; i<childList.length ; i++){
    //               if(childList[i].getAttribute("style").indexOf("font-size:") !== -1){
    //                 childList[i].style.fontSize=parseInt(childList[i].style.fontSize)*ratio+'px'
    //               }
    //             }
    //           }
    //           cloneProduct.pages[y].objectList[i].fontSize*=ratio
    //           cloneProduct.pages[y].objectList[i].Value=element.outerHTML
    //           cloneProduct.pages[y].objectList[i].modifiedHtml=element.outerHTML
    //         }
    //       }
    //     }
    //   }
    //
    //   this.$nextTick(()=>{
    //     this.product=cloneProduct
    //   })
    //
    // },

    onChangeAllowAlignmentGuides() {
      const cloneProduct = _.cloneDeep(this.product);
      cloneProduct.isAlignmentGuideOn = !cloneProduct.isAlignmentGuideOn;
      this.product = cloneProduct;
      this.onObjectSelectedCleared();
    },
    onToggleGrayScale() {
      const cloneProduct = _.cloneDeep(this.product);
      cloneProduct.IsGrayscale = !cloneProduct.IsGrayscale;
      this.product = cloneProduct;
    },
    onToggleRuler() {
      if (this.product.isRulerOn) {
        this.product.verticalGuides = [];
        this.product.horizontalGuides = [];
      }
      const cloneProduct = _.cloneDeep(this.product);
      cloneProduct.isRulerOn = !this.product.isRulerOn || false;
      this.product = cloneProduct;
    },
    onUpdateHTML(data) {
      this.product.pages[this.activePage].objectList.forEach((obj) => {
        obj.Id === data.id && (obj.Value = obj.modifiedHtml = data.html);
      });
    },
    sortContentListArray() {
      if (!this.product || !this.product.pages || !this.product.pages[this.activePage].objectList) {
        return;
      }
      for (let i = 0; i < this.product.pages.length; i++) {
        this.product.pages[i].objectList.sort(helperFunctionToReverseSortByObjectKey('PdfSortOrder'));
      }
      this.onUpdateContentListIndexOnLayerSwap(this.product.pages[this.activePage].objectList);
    },
    onUpdateContentListIndexOnLayerSwap(updatedArray) {
      const page = this.product.pages[this.activePage];
      for (let z = 0; z < updatedArray.length; z++) {
        page.objectList[z] = updatedArray[z];
      }
      if (page.objectList.length > updatedArray.length) {
        page.objectList.splice(
            updatedArray.length,
            page.objectList.length - updatedArray.length,
        );
      }
      assignPdfSortOrderTree(page.objectList);
      if (this.activeObject) {
        const selectedObject = findObjectById(page.objectList, this.activeObject.Id);
        if (selectedObject) {
          this.activeObject = selectedObject;
        }
      }
    },
    updateIsLoaderVisible(bool) {
      if (bool === true || bool === false) {
        this.isLoaderVisible = bool;
      }
    },

    updatePageContent(page) {
      this.product.pages[this.activePage].objectList = page;
    },
    clickOnMainContent() {
      // closing the colorPickerComponent
      this.$store.commit('setIsOpen', false);
    },
    selectedProductRecieved(data) {
      this.parseProductFromXML(data);
    },
    updateStyle() {
      if ('VerticalCenter') {
        this.activeObject.alignItem = 'center';
      }
    },
    onUpdateObjectAfterCrop(data) {
      const tempProduct = _.cloneDeep(this.product);
      const objectList = tempProduct.pages[this.activePage].objectList;
      let target = data.Id ? findObjectById(objectList, data.Id) : null;
      const tempIndex = data.tempIndex != null && data.tempIndex !== ''
          ? Number(data.tempIndex)
          : -1;
      if (!target && tempIndex >= 0) {
        target = objectList[tempIndex];
      }
      if (!target) {
        return;
      }
      Object.assign(target, data);
      const parentGroup = findParentGroup(objectList, target.Id);
      if (parentGroup) {
        recalculateGroupBounds(parentGroup);
      }
      clearAllSelection(objectList);
      this.product = tempProduct;
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, 'cropped Image Url');
      this.activeObject = null;
      this.selectedObjectsList = [];
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      this.rerender();
    },
    onObjectSelected(activeObject) {
      this.activeObject = activeObject;
      if (activeObject && this.activePage > -1) {
        const objectList = this.product.pages[this.activePage].objectList;
        if (activeObject.type === 'group') {
          const group = findObjectById(objectList, activeObject.Id) || activeObject;
          const children = expandSelectionForProperties([group]);
          this.selectedObjectsList = children.length
              ? JSON.parse(JSON.stringify(children))
              : [];
        } else if (findParentGroup(objectList, activeObject.Id)) {
          const child = findObjectById(objectList, activeObject.Id) || activeObject;
          this.selectedObjectsList = child ? [JSON.parse(JSON.stringify(child))] : [];
        }
      }
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
    },
    onObjectSelectedCleared() {
      if(this.$store.getters.getIsOpen) this.$store.commit('setIsOpen', false);
      this.activeObject = null;
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
      this.$store.commit('activeProduct/updatePageAnimationIndex', -1);
    },

    parseProductFromXML(xmlObject) {
      const urlSearchPart = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      let resultVariable = 'GetProductInfoResult';
      (newUrlSearchParams.has('orderitem_id') || newUrlSearchParams.has('orderitem_Id')) && (resultVariable = 'GetProductInfoForOrderResult');
      const xmlParser = new DOMParser();
      const convertedDoM = xmlParser.parseFromString(xmlObject, 'text/xml');
      const productXML = convertedDoM.getElementsByTagName(resultVariable)[0];
      // console.log('Product DATA', productXML)
      const pageWidth = productXML.getElementsByTagName('PageWidths')[0];
      const pageHeight = productXML.getElementsByTagName('PageHeights')[0];

      /* OP1: Extract all elements at root of product and convert to XML */
      const json = {};
      for (let i = 0; i < productXML.childElementCount; i++) {
        let val = productXML.childNodes[i].innerHTML;
        if (productXML.childNodes[i].innerHTML == 'true' || productXML.childNodes[i].innerHTML == 'false') {
          val = productXML.childNodes[i].innerHTML == 'true';
        }
        json[productXML.childNodes[i].tagName] = val;
      }
      /* OP1: Ended */


      const pages = [];
      const productBaseImages = this.extractProductBaseImages(json.BaseImage);
      const xCropValue = json.XCrop ? Number(json.XCrop) * 2 : 0;
      const yCropValue = json.YCrop ? Number(json.YCrop) * 2 : 0;
      const isOldOrder = json.hasOwnProperty('DesignJson');
      const tempArrayforUndRedo = [];
      for (let pageIndex = 0; pageIndex < pageWidth.children.length; pageIndex++) {
        let width = parseFloat(pageWidth.children[pageIndex].innerHTML); // this is actual width of product
        let height = parseFloat(pageHeight.children[pageIndex].innerHTML);// this is actual height of product

        isOldOrder && xCropValue > 0 && (width += xCropValue);
        isOldOrder && yCropValue > 0 && (height += yCropValue);

        pages.push({
          objectList: [],
          width,
          height,
          baseImage: productBaseImages ? productBaseImages[pageIndex] : this.product.BaseImage,
          animation: {
            speed: 1,
            style: 'pageAnimationNone',
            startTime: 0.0,
            duration: 5.0,
            onEnter: false,
            onExit: false,
            timeLineWidth: 140,
          },
        });
        tempArrayforUndRedo.push({
          animation: {
            speed: 1,
            style: 'pageAnimationNone',
            startTime: 0.0,
            duration: 5.0,
            onEnter: false,
            onExit: false,
            timeLineWidth: 140,
          },
        });
        // if (pageIndex == 5) {
        //  break;
        // } // TODO:we have 6 page to display
      }
      // this.pagesDurationUndoRedoArray.push(tempArrayforUndRedo);
      // this issue is on old order, the fixed is recalculate the width and height crop
      if (isOldOrder && pages.length) {
        const {width, height} = pages[0];
        const isChangeWidthCrop = (json.WidthCrop + xCropValue) != width;
        isChangeWidthCrop && (json.WidthCrop = width - xCropValue);
        const isChangeHeightCrop = (json.HeightCrop + yCropValue) != height;
        isChangeHeightCrop && (json.HeightCrop = height - yCropValue);
      }

      if (pages.length > 0) {
        this.activePage = 0;
      } else {
        return;
      }
      this.product = {};
      this.product = json;
      this.product.isVideoEditor = !!(this.product.isVideoEditor);
      this.product.isVideo = !!(this.product.isVideo);
      if (newUrlSearchParams.has('video_mode')) {
        const video_mode = newUrlSearchParams.get('video_mode');
        let booleanValue = false;
        if (video_mode === 'true') {
          booleanValue = true;
        }
        this.product.isVideo = booleanValue;
        this.product.isVideoEditor = booleanValue;
      }
      this.$store.commit('activeProduct/updateIsVideoMoodOn', this.product.isVideo);
      this.$store.commit('activeProduct/updateIsVideoEditor', this.product.isVideoEditor);
      this.product.pages = pages;
      this.product.scaleX = 1;
      this.product.scaleY = 1;
      this.product.isShowCrop = json.AllowCropping;
      // this.product.isAlignmentGuideOn = false;
      this.defaultProductWidth = parseInt(this.getProductSizePixel.width);
      this.defaultProductHeight = parseInt(this.getProductSizePixel.height);
      this.defaultProductName = this.getProductName;
      isOldOrder && (delete this.product.DesignJson);
      this.addObjectForUndoRedo();
      // const { AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop } = this.product;
      // this.$store.commit('setDefaultCropMarks',{ AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop } );
      // Load Color Before product Parse
      this.renderProductFontIntoDom(productXML);
      setTimeout(() => {
        this.loadPmsColorNewInfo(this.product, productXML);
      }, 0);

      // Adding property in product that are receive empty
    },
    addObjectForUndoRedo() {
      this.product.pages.forEach((page, i) => {
        const object = {
          animation: page.animation,
          name: 'none',
          type: 'pagedetails',
        };
        // this.product.pages[i].objectList.push(object);
      });
    },
    renderProductFontIntoDom(productXML) {
      const textFields = productXML.getElementsByTagName('TextField');
      const fontArray = [];
      for (let textFieldIndex = 0; textFieldIndex < textFields.length; textFieldIndex++) {
        if (textFields[textFieldIndex].getElementsByTagName('Font').length > 0) {
          fontArray.push(textFields[textFieldIndex].getElementsByTagName('Font')[0].innerHTML);
        }
      }

      this.fontFamilyLoad(fontArray);
    },
    async parseProductObject(productXML, product) {
      const textFields = productXML.getElementsByTagName('TextField');
      for (let textFieldIndex = 0; textFieldIndex < textFields.length; textFieldIndex++) {
        let textObject = new Text();
        textObject = await textObject.initFromXML(textFields[textFieldIndex]);
        const listPageIndex = textObject.data.PageNo - 1;
        // if (listPageIndex > 5 || listPageIndex > product.pages.length) {
        //   continue;
        // }
        let listObjectIndex = product.pages[listPageIndex].objectList.push(textObject.data);
        listObjectIndex -= 1;
        product.pages[listPageIndex].objectList[listObjectIndex].elementIndex = listObjectIndex;
        product.pages[listPageIndex].objectList[listObjectIndex].PageNo = listPageIndex;
      }

      const imagesFields = productXML.getElementsByTagName('ImageField');
      for (let imageFieldIndex = 0; imageFieldIndex < imagesFields.length; imageFieldIndex++) {
        let imageField = new Image(this.product.BankType);
        imageField = await imageField.initFromXML(imagesFields[imageFieldIndex]);
        const listPageIndex = imageField.data.PageNo - 1;
        if (isFDICEHNCUA(imageField.data.ImageType) && imageField.data.SvgProperty && imageField.data.SvgProperty.content) {
          const page = product.pages[listPageIndex];
          imageField.data.SvgProperty.content = applyLogoFitFromContent(
              imageField.data,
              imageField.data.SvgProperty.content,
              page,
          );
        }
        // if (listPageIndex > 5 || listPageIndex > product.pages.length) {
        //   continue;
        // }
        let listObjectIndex = product.pages[listPageIndex].objectList.push(imageField.data);
        listObjectIndex -= 1;
        product.pages[listPageIndex].objectList[listObjectIndex].elementIndex = listObjectIndex;
      }
      const backgroundFields = productXML.getElementsByTagName('BackgroundField');
      for (let backgroundFieldIndex = 0; backgroundFieldIndex < backgroundFields.length; backgroundFieldIndex++) {
        let backgroundField = new Background();
        backgroundField = await backgroundField.initFromXML(backgroundFields[backgroundFieldIndex]);
        const listPageIndex = backgroundField.data.PageNo - 1;
        // if (listPageIndex > 5 || listPageIndex > product.pages.length) {
        //   continue;
        // }
        let listObjectIndex = product.pages[listPageIndex].objectList.push(backgroundField.data);
        listObjectIndex -= 1;
        product.pages[listPageIndex].objectList[listObjectIndex].elementIndex = listObjectIndex;
        product.pages[listPageIndex].objectList[listObjectIndex].PageNo = listPageIndex;
      }
    },
    parseProductProperties(productXML, product) {
      const YCrop = productXML.getElementsByTagName('YCrop')[0];
      this.product.YCrop = YCrop.innerHTML ? YCrop.innerHTML : 0;

      const XCrop = productXML.getElementsByTagName('XCrop')[0];
      this.product.XCrop = XCrop.innerHTML ? XCrop.innerHTML : 0;


      const PageHeights = productXML.getElementsByTagName('PageHeights');
      let temp = PageHeights[0].children[0].textContent ? Number(PageHeights[0].children[0].textContent) : 0;
      this.product.PageHeights = {};
      this.product.PageHeights.double = temp;
      const PageWidths = productXML.getElementsByTagName('PageWidths');
      temp = PageWidths[0].children[0].textContent ? Number(PageWidths[0].children[0].textContent) : 0;
      this.product.PageWidths = {};
      this.product.PageWidths.double = temp;

      const WidthCrop = productXML.getElementsByTagName('WidthCrop')[0];
      this.product.WidthCrop = WidthCrop.innerHTML ? Number(WidthCrop.innerHTML) : this.product.PageWidths.double;

      const HeightCrop = productXML.getElementsByTagName('HeightCrop')[0];
      this.product.HeightCrop = HeightCrop.innerHTML ? Number(HeightCrop.innerHTML) : this.product.PageHeights.double;

      const CsvFilePath = productXML.getElementsByTagName('CsvFilePath')[0];
      this.product.CsvFilePath = CsvFilePath.innerHTML ? CsvFilePath.innerHTML : null;

      const TriviaQuestions = productXML.getElementsByTagName('TriviaQuestions')[0];
      this.product.TriviaQuestions = TriviaQuestions.innerHTML ? TriviaQuestions.innerHTML : null;

      delete this.product.Backgrounds; // this field contain xml so no need to keep in new editor.
      delete this.product.Fields;
      delete this.product.Images;

      //   this.$store.commit('setProductPages', pages);
      //  this.selectedPage = pages[0];

      // if (this.product.Id === '1805d69d-59ba-486b-80de-63137d8f46f7') {
      this.replaceResourcesWithHighResolutionResourceInProduct().then(async () => {
        await setTimeout(() => {
          this.updateProductColorList();
          this.$nextTick(() => {
            this.$store.commit('updateSelectedProduct', _.cloneDeep(this.product));
          });
        }, 3000);
      });
      // this.initiatePageWiseUndoRedoArray();
      this.loadAllAddressBoxes(this.product.Id);
      this.loadFontsByBank(this.product.Id);
      this.productPagesLength = this.product.pages.length;
      this.sortContentListArray();
      // wait from replace High Resolution resources
      setTimeout(() => {
        this.initiatePageWiseUndoRedoArray();

        // this.onAddIntoPageWiseUndoRedoArray('called by load canvas');
      }, 2000);
    },
    extractProductBaseImages(baseURLString) {
      return baseURLString.includes('\n') && baseURLString.split('\n');
    },
    async updateProductColorList() {
      EventBus.$emit('StartProductColorProcessing');
      const colorList = await this.extractColorFromProduct();
      setTimeout(() => {
        colorList.length && (this.$store.commit('updateProductColor', _.cloneDeep(colorList)));
        EventBus.$emit('StopProductColorProcessing');
      }, 2000);
    },
    async loadProductFromJson({orderJson, orderName}) {
      if (!orderJson) {
        return;
      }
      const product = JSON.parse(orderJson);
      product.pages.forEach((page, index) => {
        if (!page.animation) {
          product.pages[index].animation = {
            speed: 1,
            style: 'pageAnimationNone',
            startTime: 0.0,
            duration: 5.0,
            onEnter: false,
            onExit: false,
            timeLineWidth: 140,
          };
        }
      });
      this.product = await this.decodeTextSvgAndCroppedImageComponents(product);
      this.product.Name = orderName;
      this.activePage = 0;
      this.replaceResourcesWithHighResolutionResourceInProduct().then(async () => {
        await setTimeout(() => {
          this.updateProductColorList();
        }, 3000);
      });

      this.loadAllAddressBoxes(this.product.Id);
      this.loadFontsByBank(this.product.Id);
      try {
        this.loadPmsColorNewInfo(this.product);
      } catch (e) {

      }
      // todo: This check for old order's saved as new.
      if (this.product.DesignJson && this.product.pages.length) {
        const xCrop = (Number(product.XCrop) * 2);
        const yCrop = (Number(product.YCrop) * 2);
        const {width, height} = this.product.pages[0];
        const isChangeWidthCrop = (this.product.WidthCrop + xCrop) != width;
        isChangeWidthCrop && (this.product.WidthCrop = width - xCrop);
        const isChangeHeightCrop = (this.product.HeightCrop + yCrop) != height;
        isChangeHeightCrop && (this.product.HeightCrop = height - yCrop);
      }
      if (this.product) {
        const isVideoMoodOn = this.$store.getters['activeProduct/getIsVideoMoodOn'];
        const isVideoEditor = this.$store.getters['activeProduct/getIsVideoEditor'];

        this.product.isVideo = this.product.isVideo || isVideoMoodOn || false;
        this.product.isVideoEditor = this.product.isVideoEditor || isVideoEditor || false;

        this.$store.commit('activeProduct/updateIsVideoMoodOn', this.product.isVideo);
        this.$store.commit('activeProduct/updateIsVideoEditor', this.product.isVideoEditor);
      }
      this.productPagesLength = this.product.pages.length;
      this.defaultProductWidth = parseInt(this.getProductSizePixel.width);
      this.defaultProductHeight = parseInt(this.getProductSizePixel.height);
      setTimeout(() => {
        this.initiatePageWiseUndoRedoArray();
        this.$nextTick(() => {
          this.$store.commit('updateSelectedProduct', _.cloneDeep(this.product));
        });
      }, 2000);
    },
    async decodeTextSvgAndCroppedImageComponents(product) {
      product.Name = decodeURIComponent(product.Name);
      const objectIdList = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const page of product.pages) {
        const objects = [];
        forEachCanvasObject(page.objectList, (object) => {
          objects.push(object);
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const object of objects) {
          if (objectIdList.indexOf(object.Id) > -1) {
            object.Id = uuidv4();
          }
          objectIdList.push(object.Id);
          object.type == 'text' && (object.Value = decodeURIComponent(object.Value));
          object.type == 'text' && (object.modifiedHtml = object.Value);
          if (object.type == 'image' && object.ImageType == 'SVGImage') {
            object.SvgProperty.content = decodeURIComponent(object.SvgProperty.content);
          }

          const isEOLogo = object.DefaultImageUrl && object.DefaultImageUrl.indexOf('EOL') > -1;

          if (object.type == 'image' && isFDICEHNCUA(object.ImageType) && !object.SvgProperty) {
            object.SvgProperty = {
              content:      '',
              DefaultColor: '#000000',
              StrokeColor:  '#000000',
              StrokeWidth:  0,
              svgScaleX:    1,
              svgScaleY:    1,
              style:        'scale(1, 1)',
            };
          }

          if (object.type == 'image' && object.ImageType === 'FDICText') {
            const fdicContent = this.mergeSvgStyle(product.BankType === 'CreditUnion' ? NCUA_TEXT_BLACK_SVG.content : FDIC_TEXT_BLACK_SVG.content, object, product);
            object.SvgProperty.content = object.SvgProperty.content ? decodeURIComponent(object.SvgProperty.content) : fdicContent;
          }
          if (object.type == 'image' && object.ImageType === 'FDICTextWhite') {
            const fdicContent = this.mergeSvgStyle(product.BankType === 'CreditUnion' ? NCUA_TEXT_WHITE_SVG.content : FDIC_TEXT_WHITE_SVG.content, object, product);
            object.SvgProperty.content = object.SvgProperty.content ? decodeURIComponent(object.SvgProperty.content) : fdicContent;
          }
          if (object.type == 'image' && object.ImageType.indexOf('FDICLogo') > -1) {
            if (object.SvgProperty.content) {
              object.SvgProperty.content = decodeURIComponent(object.SvgProperty.content);
            } else {
              const logoUrl = object.DefaultImageUrl;
              const shapeInput = await this.loadSvg(logoUrl);
              console.log('shapeInput', shapeInput);
              // const shapeInput = isEOLogo ? FDIC_LOGO_BLACK_SVG : FDIC_LOGO_2_BLACK_SVG;

              const style = `style="transform-origin: left top; transform: scale(${1}, ${1});"`;
              shapeInput.content = shapeInput.content && shapeInput.content.indexOf('style="transform-origin: left top 0px;"') > -1 ? shapeInput.content.replace('style="transform-origin: left top 0px;"', style) : shapeInput.content.replace('style="transform-origin: left top;"', style); // check for the browser compatibility

              let counter = 1;
              const clipMap = {};

              // Replace clipPath ids to ensure uniqueness
              shapeInput.content = shapeInput.content.replace(/<clipPath\s+id="(.*?)"/g, (_, oldId) => {
                const newId = `clip_new_${counter++}`;
                clipMap[oldId] = newId;
                return `<clipPath id="${newId}"`;
              });

              // Replace all clip-path="url(#...)" references
              shapeInput.content = shapeInput.content.replace(/clip-path="url\(#(.*?)\)"/g, (_, oldId) => {
                const newId = clipMap[oldId] || oldId;
                return `clip-path="url(#${newId})"`;
              });

              // (Optional) Replace references inside style="clip-path:url(#...);" if needed
              shapeInput.content = shapeInput.content.replace(/clip-path:\s*url\(#(.*?)\)/g, (_, oldId) => {
                const newId = clipMap[oldId] || oldId;
                return `clip-path:url(#${newId})`;
              });

              // const fdicContent          = this.mergeSvgStyle(isEOLogo ? FDIC_LOGO_2_BLACK_SVG.content : FDIC_LOGO_BLACK_SVG.content, object, product);
              object.SvgProperty.content = shapeInput.content;
            }
          }
          if (object.type == 'image' && object.ImageType === 'FDICLogoWhite') {
            // const fdicContent          = this.mergeSvgStyle(isEOLogo ? FDIC_LOGO_2_WHITE_SVG.content : FDIC_LOGO_WHITE_SVG.content, object, product);
            // object.SvgProperty.content = object.SvgProperty.content ? decodeURIComponent(object.SvgProperty.content) : fdicContent;
          }
          if (object.type == 'image' && isFDICEHNCUA(object.ImageType) && object.SvgProperty && object.SvgProperty.content) {
            object.SvgProperty.content = applyLogoFitFromContent(
                object,
                object.SvgProperty.content,
                { width: page.width, height: page.height },
            );
          }
          if (object.type == 'image' && object.croppedSrc != 'none') {
            object.DefaultImageUrl = decodeURIComponent(object.DefaultImageUrl);
            object.croppedSrc = decodeURIComponent(object.croppedSrc);
            object.HighResPath = decodeURIComponent(object.HighResPath);
            object.croppedHighResPath = decodeURIComponent(object.croppedHighResPath);
          }
          if (object.type == 'image' && object.AlternativeImageUrlsResVersion) {
            object.AlternativeImageUrlsResVersion.forEach((cur) => {
              if (cur.ImageThumbnailPath && cur.ImageThumbnailPathV2) {
                cur.ImageThumbnailPath = decodeURIComponent(cur.ImageThumbnailPath);
                cur.ImageThumbnailPathV2 = decodeURIComponent(cur.ImageThumbnailPathV2);
              }
            });
          }
          if (object.type === 'text') {
            if (!object.textShadow) {
              object.textShadow = {
                textEffect: 'none',
                angle: 0,
                distance: 0,
                shadowBlur: 0,
                shadowColor: 'rgb(252,252,252)',
                transparency: 0,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
              };
            }

            if (!object.outLine) {
              object.outLine = {
                textEffect: 'none',
                strokeWidth: 0,
                strokeColor: '#000000',
              };
            }
          }
          if (object.type === 'shape' || object.type === 'text') {
            if (object.isGradient === undefined) {
              object.isGradient = false;
            }

            if (!object.gradient) {
              object.gradient = {
                angle: 0,
                colors: [
                  {
                    id: '1',
                    position: 0,
                    color: 'red',
                    isSelected: true,
                    rgba: 'rgba(255,0,0,1)',
                  },
                  {
                    id: '2',
                    position: 94,
                    color: 'yellow',
                    isSelected: false,
                    rgba: 'rgba(234,239,44,1)',
                  },
                ],
              };
            }
          }
        }
      }
      return product || {};
    },
    async loadSvg(logoUrl) {
      const data = await fetchingSvg(logoUrl);
      return data;
    },
    async replaceResourcesWithHighResolutionResourceInProduct() {
      console.log('replaceResourcesWithHighResolutionResourceInProduct');
      await this.product.pages.forEach((page) => {
        page.objectList.forEach((obj) => {
          if (obj.type === 'image') {
            if (obj.hasOwnProperty('HighResPath') && obj.DefaultImageUrl && !obj.DefaultImageUrl.trimEnd().endsWith('.svg')) {
              const fileType = obj.HighResPath && obj.HighResPath.substring(obj.HighResPath.lastIndexOf('.') + 1, obj.HighResPath.length);
              if (fileType === 'pdf') {
                const temp_obj = obj;
                axios.post(`https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?pdf-url=${obj.HighResPath}&productId=${this.product.Id}`)
                    .then(async (res) => {
                      temp_obj.DefaultImageUrl = res.data.svg;
                      temp_obj.HighResPath = '';
                      // Fetch and create SVG markup
                      const logoUrl = temp_obj.DefaultImageUrl;
                      const shapeInput = await this.loadSvg(logoUrl);
                      // const shapeInput = isEOLogo ? FDIC_LOGO_BLACK_SVG : FDIC_LOGO_2_BLACK_SVG;

                      const style = `style="transform-origin: left top; transform: scale(${1}, ${1});"`;
                      shapeInput.content = shapeInput.content && shapeInput.content.indexOf('style="transform-origin: left top 0px;"') > -1 ? shapeInput.content.replace('style="transform-origin: left top 0px;"', style) : shapeInput.content.replace('style="transform-origin: left top;"', style); // check for the browser compatibility

                      let counter = 1;
                      const clipMap = {};

                      // Replace clipPath ids to ensure uniqueness
                      shapeInput.content = shapeInput.content.replace(/<clipPath\s+id="(.*?)"/g, (_, oldId) => {
                        const newId = `clip_new_${counter++}`;
                        clipMap[oldId] = newId;
                        return `<clipPath id="${newId}"`;
                      });

                      // Replace all clip-path="url(#...)" references
                      shapeInput.content = shapeInput.content.replace(/clip-path="url\(#(.*?)\)"/g, (_, oldId) => {
                        const newId = clipMap[oldId] || oldId;
                        return `clip-path="url(#${newId})"`;
                      });

                      // (Optional) Replace references inside style="clip-path:url(#...);" if needed
                      shapeInput.content = shapeInput.content.replace(/clip-path:\s*url\(#(.*?)\)/g, (_, oldId) => {
                        const newId = clipMap[oldId] || oldId;
                        return `clip-path:url(#${newId})`;
                      });
                      shapeInput.content = this.getUpdatedSvg(shapeInput, temp_obj);

                      // const fdicContent          = this.mergeSvgStyle(isEOLogo ? FDIC_LOGO_2_BLACK_SVG.content : FDIC_LOGO_BLACK_SVG.content, object, product);
                      temp_obj.SvgProperty.content = shapeInput.content;
                    })
                    .catch((e) => {
                      console.error(e);
                      temp_obj.DefaultImageUrl = '';
                    });
              } else {
                (obj.ImageType !== 'Image') && (obj.DefaultImageUrl = obj.HighResPath);
                // obj.DefaultImageUrl = obj.HighResPath
              }
            } else if (obj.DefaultImageUrl && obj.DefaultImageUrl.trimEnd().endsWith('.svg') && obj.hasOwnProperty('HighResPath') && obj.HighResPath.trimEnd().endsWith('.pdf')) {
              obj.DefaultImageUrl = `${obj.DefaultImageUrl}?highResImage=${obj.HighResPath}`;
            }
          }
        });
      });
    },
    replaceResources() {
      const allImageElements = document.querySelectorAll('[data-type= "image"]');
      if (allImageElements) {
        for (let i = 0; i < allImageElements.length; i++) {
          this.hardCodedLogicForDemoProduct(allImageElements[i].dataset.elementindex);
          allImageElements[i].firstElementChild.src = this.product.pages[this.getActivePageIndex].objectList[allImageElements[i].dataset.elementindex].srcForPdf;
        }
      }
    },
    hardCodedLogicForDemoProduct(index) {
      const objectIdVsPdfSrc = {
        'b5222806-aaa0-4082-a56a-909af321f093': '//173.230.137.214/htmlengine/img/fiblogo.svg',
        'e62076cf-7f94-4093-acea-1698fc116bb0': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/fdiclogo.svg',
        'b994abba-961f-4045-ab64-b0c3e65e0116': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/fdictext.svg',
        // 'd7d987a3-c0dd-4de8-8263-aaa8f1cfd9e9': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/ThinkstockPhotos-125917776019.jpg',
        '3ff179d8-37cc-496d-b247-082d346b181a': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder01.svg',
        '5557305c-5b0e-4a71-8ee5-e0d4a0aa7ac1': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder2044.svg',
        'e9ca3fc1-66e3-46b7-91bf-f2f8c4b96674': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder104.svg',
      };
      this.product.pages[this.getActivePageIndex].objectList[index].srcForPdf = objectIdVsPdfSrc[this.product.pages[this.getActivePageIndex].objectList[index].Id];
    },
    /*
                * @Method:loadFonts
                * @param:path
                * @description:loaded fonts in document get from xml and store fonts
                *
                * */
    loadFonts(path) {
      // for time beign get fonts locally
      const xmlParser = new DOMParser();
      const convertedDoM = xmlParser.parseFromString(this.fontsXml, 'text/xml');
      const fontsResult = convertedDoM.getElementsByTagName('GetFontsByBankIdResult');
      let jsonFonts = [];

      if (fontsResult.length > 0) {
        const fonts = fontsResult[0].children;

        for (let ilterFont = 0; ilterFont < fonts.length; ilterFont++) {
          const jsonFontObj = {
            name: fonts[ilterFont].firstElementChild.innerHTML,
            path: fonts[ilterFont].lastElementChild.innerHTML,
            id: '',
            isFavourite: false,
          };
          if (jsonFonts.indexOf(jsonFontObj) === -1) {
            jsonFonts.push(jsonFontObj);
          }
        }
        jsonFonts = [...jsonFonts.reduce((map, obj) => map.set(obj.name, obj), new Map()).values()];
        this.$store.commit('setproductfontarray', jsonFonts);
      }
    },
    getCMYKColor(path) {
      const xmlParser = new DOMParser();
      const convertedDoM = xmlParser.parseFromString(this.CMYKColor, 'text/xml');
      const pmsColor = convertedDoM.getElementsByTagName('GetPmsColorNewInfoResult')[0];
      // const newPMSColor    = pmsColor.getElementsByTagName('BankNewPmsColors')[0];
      const allNewPMSColor = pmsColor.getElementsByTagName('AllNewPmsColors')[0];
      const bankId = pmsColor.getElementsByTagName('BankId')[0];
      const bankName = pmsColor.getElementsByTagName('BankName')[0];
      const usePmsColor = allNewPMSColor.getElementsByTagName('PmsColorNew');
      const bankPMSColor = {bankId, bankName, bankPmsColorList: []};

      for (let pmsColorIndex = 0; pmsColorIndex < usePmsColor.length; pmsColorIndex++) {
        const pmsColorObj = {
          id: -1, name: 'white', colorRGB: '', colorCMYK: '',
        };

        for (const pmsColorObject of usePmsColor[pmsColorIndex].children) {
          switch (pmsColorObject.tagName) {
            case 'Id':
              pmsColorObj.id = pmsColorObject.innerHTML;
              break;
            case 'Name':
              pmsColorObj.name = pmsColorObject.innerHTML;
              break;
            case 'DisplayColorTextRGB':
              pmsColorObj.colorRGB = pmsColorObject.innerHTML;
              break;
            case 'DisplayColorTextCMYK':
              pmsColorObj.colorCMYK = pmsColorObject.innerHTML;
              break;
          }
        }
        bankPMSColor.bankPmsColorList.push(pmsColorObj);
      }
      this.$store.commit('setBankPMSColor', bankPMSColor);
    },
    onObjectAdding(object) {
      object.pageNo = this.activePage;
      this.product.pages[this.activePage].objectList.unshift(object);
      (object.type === 'shape' || object.ImageType == 'WhiteboxLogo' || object.ImageType == 'SVGImage') && EventBus.$emit('updateProductColor');
      this.onUpdateContentListIndexOnLayerSwap(this.product.pages[this.activePage].objectList); // funtion called so that the correct index assingn to the new adding object
      setTimeout(() => {
        this.onAddIntoPageWiseUndoRedoArray('called by on object adding');
        if (object.type === 'image' && object.ImageType && object.ImageType !== 'WhiteboxLogo' && object.ImageType !== 'FDICText' && object.ImageType !== 'FDICLogo' && object.ImageType !== 'SVGImage') {
          this.$store.commit('activeProduct/updateCurrentUploadFile', this.$store.getters['activeProduct/getCurrentUploadFile'] + 1);
        }
        const totalUploFiles = this.$store.getters['activeProduct/getTotalUploadFiles'];
        const currentUploadFile = this.$store.getters['activeProduct/getCurrentUploadFile'];
        console.log(totalUploFiles, currentUploadFile);
        if (totalUploFiles === currentUploadFile) {
          EventBus.$emit('showHideLoader', false);
          this.$store.commit('setIsAddNewImageModal', false);
          this.$store.commit('activeProduct/updateTotalUploadFiles', 0);
          this.$store.commit('activeProduct/updateCurrentUploadFile', 0);
          EventBus.$emit(ApplicationEventTypes.Canvas.CANVAS_RE_RENDER);
        }
      }, 200);
    },
    changeToggleBulletList(value) {
      const {elementIndex} = this.activeObject;
      const object = this.product.pages[this.activePage].objectList[elementIndex];
      object.html = object.editor.getHTML();
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
    },
    changeToggleNumberList(value) {
      const {elementIndex} = this.activeObject;
      const object = this.product.pages[this.activePage].objectList[elementIndex];
      object.editor.chain()
          .focus()
          .toggleOrderedList()
          .run();
      object.html = object.editor.getHTML();
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
    },
    changetoggleSupperScriptList(value) {
      const {elementIndex} = this.activeObject;
      const object = this.product.pages[this.activePage].objectList[elementIndex];
      !value && object.editor.chain()
          .focus()
          .unsetSubscript()
          .run();
      object.html = object.editor.getHTML();
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
    },
    changetoggleSubScriptList(value) {
      const {elementIndex} = this.activeObject;
      const object = this.product.pages[this.activePage].objectList[elementIndex];
      !value && object.editor.chain()
          .focus()
          .unsetSuperscript()
          .run();
      object.html = object.editor.getHTML();
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
    },
    onReceivePushedValue(receivedObject) {
      this.product.pages[this.activePage].objectList.push(receivedObject);
    },

    getSelectedObjectsList(selectedTargets) {
      const objectList = this.product.pages[this.getActivePageIndex].objectList;
      const rawTargets = [];
      selectedTargets[0].forEach((target) => {
        const obj = findObjectById(objectList, target.id);
        if (obj) {
          rawTargets.push(obj);
        }
      });

      const onlyGroupChildren = rawTargets.length > 0
          && rawTargets.every(obj => obj.type !== 'group' && findParentGroup(objectList, obj.Id));
      if (onlyGroupChildren) {
        const liveChildren = resolveLiveObjects(objectList, rawTargets);
        this.selectedObjectsList = liveChildren.length ? JSON.parse(JSON.stringify(liveChildren)) : [];
        return;
      }

      const topLevelById = new Map();
      rawTargets.forEach((obj) => {
        const parent = findParentGroup(objectList, obj.Id);
        const top = parent || obj;
        topLevelById.set(top.Id, top);
      });
      const targets = Array.from(topLevelById.values());

      const propertyTargets = targets.some(t => t && t.type === 'group')
          ? expandSelectionForProperties(targets)
          : targets;
      const liveTargets = resolveLiveObjects(objectList, propertyTargets);
      this.selectedObjectsList = liveTargets.length ? JSON.parse(JSON.stringify(liveTargets)) : [];
    },
    onClearMultiSelection() {
      console.log('onClearMultiSelection');
      this.selectedObjectsList = [];
      // this.rerender();
    },
    resetPagesThumbnailWidthAndTime() {
      this.product.pages.forEach((page) => {
        page.animation.duration = 5;
        page.animation.timeLineWidth = 140;
      });
    },

    flipObjects(direction) {
      this.product.pages[this.activePage].objectList.forEach((obj) => {
        if (this.selectedObjectsList.some(o => o.Id === obj.Id)) {
          console.log('should flip now');
          if (direction == 1) {
            if (obj.IsHFlipped == false) { obj.IsHFlipped = true; } else { obj.IsHFlipped = false; }
          }
          if (direction == -1) {
            if (obj.IsVFlipped == false) { obj.IsVFlipped = true; } else { obj.IsVFlipped = false; }
          }
        }
      });
      EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.UPDATED, this.onObjectUpdated);
      this.emitUndoRedoRequest('called by Flip Update');
    },

    verticalGuideUpdate(vGuides) {
      this.product.verticalGuides = _.cloneDeep(vGuides);
    },

    horizontalGuideUpdate(hGuides) {
      this.product.horizontalGuides = _.cloneDeep(hGuides);
    },

    changeImageBorderWidth(borderWidth) {
      const objectList = this.product.pages[this.activePage].objectList;
      const targets = getPropertyApplyTargets(
          objectList,
          this.selectedObjectsList,
          this.activeObject,
      );

      targets.forEach((obj) => {
        if (!obj || obj.type !== 'image') { return; }
        // Must use findObjectById — group children are nested, not top-level in objectList
        const activeObject = findObjectById(objectList, obj.Id);
        if (!activeObject) { return; }

        if (!activeObject.outline) {
          this.$set(activeObject, 'outline', { color: activeObject.borderColor || '#000', distance: borderWidth });
        } else {
          this.$set(activeObject.outline, 'distance', borderWidth);
        }
      });
      EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_IMAGE_BORDER_WIDTH_UI, borderWidth);
    },

    updateTextFromAi(text) {
      console.log('UPDATE TEXT FROM AI IN MAIN CONTENT', text);
      console.log('activeObject', this.activeObject);
      this.activeObject.Value = text;
      this.product.pages[this.activePage].objectList.forEach((obj) => {
        if (obj.Id === this.activeObject.Id) {
          obj.Value = text;
          obj.modifiedHtml = text;
        }
      });
      this.rerender();
      setTimeout(() => {
        EventBus.$emit('onObjectSelectedFromRightPanel', this.activeObject.Id);
      });
    },

    mergeSvgStyle(svgString, object, jsonProduct) {
      const width  = parseInt(object.Width, 10);
      const height = parseInt(object.Height, 10);

      const isEOLogo = object.DefaultImageUrl && object.DefaultImageUrl.indexOf('EOL') > -1;

      let svgWidth  = 0;
      let svgHeight = 0;
      if (object.ImageType === 'FDICText') {
        svgWidth  = jsonProduct.BankType === 'CreditUnion' ? NCUA_TEXT_BLACK_SVG.width : FDIC_TEXT_BLACK_SVG.width;
        svgHeight = jsonProduct.BankType === 'CreditUnion' ? NCUA_TEXT_BLACK_SVG.height : FDIC_TEXT_BLACK_SVG.height;
      } else if (object.ImageType === 'FDICTextWhite') {
        svgWidth  = jsonProduct.BankType === 'CreditUnion' ? NCUA_TEXT_WHITE_SVG.width : FDIC_TEXT_WHITE_SVG.width;
        svgHeight = jsonProduct.BankType === 'CreditUnion' ? NCUA_TEXT_WHITE_SVG.height : FDIC_TEXT_WHITE_SVG.height;
      } else if (object.ImageType === 'FDICLogo') {
        svgWidth  = isEOLogo ? FDIC_LOGO_2_BLACK_SVG.width : FDIC_LOGO_BLACK_SVG.width;
        svgHeight = isEOLogo ? FDIC_LOGO_2_BLACK_SVG.height : FDIC_LOGO_BLACK_SVG.height;
      } else { // FDICLogoWhite
        svgWidth  = isEOLogo ? FDIC_LOGO_2_WHITE_SVG.width : FDIC_LOGO_WHITE_SVG.width;
        svgHeight = isEOLogo ? FDIC_LOGO_2_WHITE_SVG.height : FDIC_LOGO_WHITE_SVG.height;
      }

      if (width < 2 || height < 2) { return; }

      const fit = getSvgScaleToFitBox(object.Width, object.Height, svgWidth, svgHeight, true);
      if (object.SvgProperty) {
        object.SvgProperty.svgScaleX = fit.scaleX;
        object.SvgProperty.svgScaleY = fit.scaleY;
        object.SvgProperty.style     = `scale(${fit.scaleX}, ${fit.scaleY})`;
      }
      return applySvgScaleTransform(svgString, fit.scaleX, fit.scaleY);
    },
    getUpdatedSvg(svgData, object, pageSize) {
      if (isFDICEHNCUA(object.ImageType)) {
        return applyLogoFitFromContent(
            object,
            svgData.content,
            pageSize,
            svgData.width,
            svgData.height,
        );
      }
      const fit = getSvgScaleToFitBox(object.Width, object.Height, svgData.width, svgData.height, false);
      return applySvgScaleTransform(svgData.content, fit.scaleX, fit.scaleY);
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-left-panel {
  flex: 0 0 344px;
  width: 344px;
}

.flex-center-panel {
  flex: 1 1 auto;
}

.flex-right-panel {
  flex: 0 0 256px;
  height: calc(100vh - 68px);
  overflow: hidden;
}

.loader-styling {
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.79);
}

.inner-Loader ::v-deep .vue-simple-spinner-text {
  color: #52A7E1;
}

.set-z-index {
  z-index: 100000;
}
</style>
